/*
 * @license
 * Modular Theme (c) Presidio Creative Themes
 *
 * Modified versions of the theme code
 * are not supported by Presidio Creative.
 *
 */
!(function (t, e, i, s) {
    "use strict";
    !(function () {
        const t = { NODE_ENV: "production" };
        try {
            if (process) return (process.env = Object.assign({}, process.env)), void Object.assign(process.env, t);
        } catch (t) {}
        globalThis.process = { env: t };
    })(),
        (window.theme = window.theme || {}),
        (window.theme.subscribers = {}),
        (window.theme.sizes = { mobile: 480, small: 768, large: 1024, widescreen: 1320 }),
        (window.theme.dimensions = { headerScrolled: 60 }),
        (window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
        (window.theme.a11yTrigger = null),
        (function () {
            function t(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect();
                return s.top >= 0 && s.bottom <= i && s.left >= 0 && s.right <= e;
            }
            function e(t) {
                var e = window.innerWidth || document.documentElement.clientWidth,
                    i = window.innerHeight || document.documentElement.clientHeight,
                    s = t.getBoundingClientRect(),
                    o = (s.left >= 0 && s.left <= e) || (s.right >= 0 && s.right <= e),
                    n = (s.top >= 0 && s.top <= i) || (s.bottom >= 0 && s.bottom <= i);
                return o && n;
            }
            window.visibilityHelper = {
                isElementTotallyVisible: t,
                isElementPartiallyVisible: e,
                inViewportPartially: function (t, i) {
                    function s() {
                        var s = e(t);
                        s != o && ((o = s), "function" == typeof i && i(s, t));
                    }
                    var o = e(t);
                    window.addEventListener("load", s),
                        window.addEventListener("resize", s),
                        window.addEventListener("scroll", s);
                },
                inViewportTotally: function (e, i) {
                    function s() {
                        var s = t(e);
                        s != o && ((o = s), "function" == typeof i && i(s, e));
                    }
                    var o = t(e);
                    window.addEventListener("load", s),
                        window.addEventListener("resize", s),
                        window.addEventListener("scroll", s);
                },
            };
        })(),
        (window.theme.getWindowWidth = function () {
            return document.documentElement.clientWidth || document.body.clientWidth || window.innerWidth;
        }),
        (window.theme.getWindowHeight = function () {
            return document.documentElement.clientHeight || document.body.clientHeight || window.innerHeight;
        }),
        (window.theme.isMobile = function () {
            return window.matchMedia(`(max-width: ${window.theme.sizes.mobile - 1}px)`).matches;
        }),
        (window.theme.isSmall = function () {
            return window.matchMedia(`(max-width: ${window.theme.sizes.small - 1}px)`).matches;
        }),
        (window.theme.isLarge = function () {
            return window.matchMedia(`(min-width: ${window.theme.sizes.large}px)`).matches;
        });
    window.theme.PUB_SUB_EVENTS = {
        cartUpdate: "cart-update",
        quantityUpdate: "quantity-update",
        optionValueSelectionChange: "option-value-selection-change",
        variantChange: "variant-change",
        cartError: "cart-error",
    };
    let o = {};
    (window.publish = function (t, e) {
        if (o[t]) {
            const i = o[t].map((t) => t(e));
            return Promise.all(i);
        }
        return Promise.resolve();
    }),
        (window.subscribe = function (t, e) {
            return (
                void 0 === o[t] && (o[t] = []),
                (o[t] = [...o[t], e]),
                function () {
                    o[t] = o[t].filter((t) => t !== e);
                }
            );
        });
    let n = class extends HTMLElement {
        connectedCallback() {
            (this.accordions = this.querySelectorAll("[data-accordion]")),
                this.accordions.forEach((t) => {
                    const e = t.querySelector("[data-accordion-trigger]"),
                        i = t.querySelector("[data-accordion-body]");
                    e &&
                        i &&
                        (e.addEventListener("click", (t) => this.onCollapsibleClick(t)),
                        i.addEventListener("transitionend", (e) => {
                            if (e.target === i) {
                                var s;
                                if ("true" == t.getAttribute("open"))
                                    this.setBodyHeight(i, "auto"),
                                        null === (s = t.querySelector("input, button, a")) || void 0 === s || s.focus();
                                "false" == t.getAttribute("open") &&
                                    (t.removeAttribute("open"), this.setBodyHeight(i, ""));
                            }
                        }));
                }),
                this.addEventListener("keyup", (t) => this.onKeyUp(t));
        }
        open(t) {
            if ("true" == t.getAttribute("open")) return;
            const e = t.querySelector("[data-accordion-body]"),
                i = t.querySelector("[data-accordion-content]");
            t.setAttribute("open", !0), this.setBodyHeight(e, i.offsetHeight);
        }
        close(t) {
            if (!t.hasAttribute("open")) return;
            const e = t.querySelector("[data-accordion-body]"),
                i = t.querySelector("[data-accordion-content]");
            this.setBodyHeight(e, i.offsetHeight),
                t.setAttribute("open", !1),
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        this.setBodyHeight(e, 0);
                    });
                });
        }
        setBodyHeight(t, e) {
            t.style.height = "auto" !== e && "" !== e ? `${e}px` : e;
        }
        onCollapsibleClick(t) {
            t.preventDefault();
            const e = t.target.closest("[data-accordion]");
            if (!e) return;
            this.hasAttribute("single") &&
                this.accordions.forEach((t) => {
                    t.hasAttribute("open") &&
                        t !== e &&
                        requestAnimationFrame(() => {
                            this.close(t);
                        });
                }),
                e.hasAttribute("open") ? this.close(e) : this.open(e);
        }
        onKeyUp(t) {
            const e = this.querySelector("details[open]");
            var i;
            "Escape" == t.code &&
                e &&
                (null === (i = e.querySelector("summary")) || void 0 === i || i.dispatchEvent(new Event("click")));
        }
        constructor() {
            super();
        }
    };
    customElements.get("accordion-elements") || customElements.define("accordion-elements", n);
    function r() {
        const { windowHeight: t, headerInitialHeight: e, headerHeight: i, footerHeight: s } = theme.readHeights();
        document.documentElement.style.setProperty("--header-height", `${i}px`),
            document.documentElement.style.setProperty("--footer-height", `${s}px`),
            document.documentElement.style.setProperty("--content-full", t - i + "px"),
            document.documentElement.style.setProperty("--content-min", t - i - s + "px");
    }
    function a(t) {
        const e = document.querySelector(t);
        return e ? e.offsetHeight : 0;
    }
    (window.theme.formatMoney = function (t, e) {
        "string" == typeof t && (t = t.replace(".", ""));
        let i = "";
        const s = /\{\{\s*(\w+)\s*\}\}/,
            o = e || "${{amount}}";
        function n(t, e = 2, i = ",", s = ".") {
            if (isNaN(t) || null == t) return 0;
            const o = (t = (t / 100).toFixed(e)).split(".");
            return o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${i}`) + (o[1] ? s + o[1] : "");
        }
        switch (o.match(s)[1]) {
            case "amount":
                i = n(t, 2);
                break;
            case "amount_no_decimals":
                i = n(t, 0);
                break;
            case "amount_with_comma_separator":
                i = n(t, 2, ".", ",");
                break;
            case "amount_no_decimals_with_comma_separator":
                i = n(t, 0, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                i = n(t, 2, "'", ".");
                break;
            case "amount_no_decimals_with_space_separator":
                i = n(t, 0, " ", "");
                break;
            case "amount_with_space_separator":
                i = n(t, 2, " ", ",");
                break;
            case "amount_with_period_and_space_separator":
                i = n(t, 2, " ", ".");
        }
        return o.replace(s, i);
    }),
        (window.theme.debounce = function (t, e) {
            let i;
            return function () {
                if (t) {
                    const s = () => t.apply(this, arguments);
                    clearTimeout(i), (i = setTimeout(s, e));
                }
            };
        }),
        (function () {
            if (window.matchMedia("(orientation: portrait)").matches) return "portrait";
            if (window.matchMedia("(orientation: landscape)").matches);
        })(),
        (window.theme.readHeights = function () {
            const t = {};
            return (
                (t.windowHeight = window.innerHeight),
                (t.footerHeight = a('[data-section-type*="footer"]')),
                (t.headerHeight = a("[data-header-height].header--has-scrolled") || 60),
                (t.headerInitialHeight = a("[data-header-height]:not(.header--has-scrolled)")),
                t
            );
        }),
        r(),
        window.addEventListener("DOMContentLoaded", r),
        document.addEventListener("theme:resize", r),
        document.addEventListener("shopify:section:load", r);
    let l = class extends HTMLElement {
        loadContent(t = !0) {
            if ((window.theme.pauseAllMedia(), !this.getAttribute("loaded"))) {
                const e = document.createElement("div");
                e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)),
                    this.setAttribute("loaded", !0);
                const i = this.appendChild(e.querySelector("video, model-viewer, iframe"));
                t && i.focus(), "VIDEO" == i.nodeName && i.getAttribute("autoplay") && i.play();
            }
        }
        constructor() {
            super();
            const t = this.querySelector("[data-deferred-media-button]");
            null == t || t.addEventListener("click", this.loadContent.bind(this));
        }
    };
    customElements.get("deferred-media") || customElements.define("deferred-media", l),
        (window.theme.DeferredMedia = window.theme.DeferredMedia || l),
        customElements.get("collapsible-elements") ||
            customElements.define(
                "collapsible-elements",
                class extends HTMLElement {
                    connectedCallback() {
                        this.triggers.forEach((t) => {
                            t.addEventListener("click", (e) => this.collapsibleToggleEvent(e, t)),
                                t.addEventListener("keyup", (e) => this.collapsibleToggleEvent(e, t));
                        });
                    }
                    collapsibleToggleEvent(t, e) {
                        t.preventDefault();
                        const i = e.getAttribute("aria-controls"),
                            s = e.hasAttribute("data-accordion"),
                            o = document.getElementById(i),
                            n = e.parentNode,
                            r = n.classList.contains("is-expanded"),
                            a = "Space" === t.code,
                            l = "Escape" === t.code;
                        let c = o.querySelector("[data-collapsible-content]").offsetHeight;
                        if ((!t.code || a || l) && (r || !l)) {
                            if (r)
                                setTimeout(() => {
                                    (c = 0), this.setDropdownHeight(o, c, r);
                                }, 0);
                            else if (s) {
                                getSiblings(n).forEach((t) => {
                                    if (t.classList.contains("is-expanded")) {
                                        t.querySelector("[data-collapsible-trigger]").dispatchEvent(new Event("click"));
                                    }
                                });
                            }
                            e.setAttribute("aria-expanded", !r),
                                n.classList.toggle("is-expanded", !r),
                                this.setDropdownHeight(o, c, r);
                        }
                    }
                    setDropdownHeight(t, e, i) {
                        (t.style.maxHeight = `${e}px`), t.setAttribute("aria-hidden", i);
                        let s = "none";
                        this.resetHeight && clearTimeout(this.resetHeight),
                            0 === e && (s = null),
                            (this.resetHeight = setTimeout(() => {
                                t.style.maxHeight = s;
                            }, 500));
                    }
                    getSiblings(t) {
                        return Array.prototype.filter.call(t.parentNode.children, function (e) {
                            return e !== t;
                        });
                    }
                    constructor() {
                        super(),
                            (this.triggers = this.querySelectorAll("[data-collapsible-trigger]")),
                            (this.resetHeight = 0);
                    }
                }
            ),
        (window.theme.pauseAllMedia = function () {
            document.querySelectorAll('[data-host="youtube"]').forEach((t) => {
                t.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
            }),
                document.querySelectorAll('[data-host="vimeo"]').forEach((t) => {
                    t.contentWindow.postMessage('{"method":"pause"}', "*");
                }),
                document.querySelectorAll("video").forEach((t) => t.pause()),
                document.querySelectorAll("product-model").forEach((t) => {
                    t.modelViewerUI && t.modelViewerUI.pause();
                });
        }),
        customElements.get("product-form") ||
            customElements.define(
                "product-form",
                class extends HTMLElement {
                    onSubmitHandler(t) {
                        t.preventDefault(),
                            document.dispatchEvent(
                                new CustomEvent("theme:cart:add", {
                                    detail: { button: this.submitButton },
                                    bubbles: !1,
                                })
                            );
                        this.closest("quick-add-modal") || (window.a11y.lastElement = this.submitButton);
                    }
                    toggleSubmitButton(t = !0, e) {
                        t
                            ? (this.submitButton.setAttribute("disabled", "disabled"), e && this.setButtonLabel(e))
                            : (this.submitButton.removeAttribute("disabled"),
                              this.setButtonLabel(e || window.theme.strings.addToCart));
                    }
                    setButtonLabel(t) {
                        const e = this.submitButtonText.querySelector("[data-product-price]");
                        (this.submitButtonText.textContent = t), e && this.submitButtonText.appendChild(e);
                    }
                    get variantIdInput() {
                        return this.form.querySelector('[name="id"]');
                    }
                    constructor() {
                        super(),
                            (this.form = this.querySelector("form")),
                            (this.variantIdInput.disabled = !1),
                            this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
                            (this.cart = document.querySelector("cart-drawer")),
                            (this.submitButton = this.querySelector('[type="submit"]')),
                            (this.submitButtonText = this.submitButton.querySelector("[data-add-to-cart-text]")),
                            document.querySelector("cart-drawer") &&
                                this.submitButton.setAttribute("aria-haspopup", "dialog"),
                            (this.hideErrors = "true" === this.dataset.hideErrors);
                    }
                }
            ),
        customElements.get("popout-select") ||
            customElements.define(
                "popout-select",
                class extends HTMLElement {
                    connectedCallback() {
                        (this.popoutList = this.querySelector("[data-popout-list]")),
                            (this.popoutToggle = this.querySelector("[data-popout-toggle]")),
                            (this.popoutToggleText = this.querySelector("[data-popout-toggle-text]")),
                            (this.popoutInput =
                                this.querySelector("[data-popout-input]") ||
                                this.parentNode.querySelector("[data-popout-input]") ||
                                this.parentNode.parentNode.querySelector("[data-quantity-input]")),
                            (this.popoutOptions = this.querySelectorAll("[data-popout-option]")),
                            (this.productGridItem = this.popoutList.closest("[data-grid-item]")),
                            (this.fireSubmitEvent = this.hasAttribute("submit")),
                            (this.popupToggleFocusoutEvent = (t) => this.onPopupToggleFocusout(t)),
                            (this.popupListFocusoutEvent = (t) => this.onPopupListFocusout(t)),
                            (this.popupToggleClickEvent = (t) => this.onPopupToggleClick(t)),
                            (this.keyUpEvent = (t) => this.onKeyUp(t)),
                            (this.bodyClickEvent = (t) => this.onBodyClick(t)),
                            this._connectOptions(),
                            this._connectToggle(),
                            this._onFocusOut(),
                            this.popupListSetDimensions();
                    }
                    onPopupToggleClick(t) {
                        const e = "true" === t.currentTarget.getAttribute("aria-expanded");
                        if (this.productGridItem) {
                            const t = this.productGridItem.querySelector("[data-product-image]");
                            t && t.classList.toggle("is-visible", !e),
                                (this.popoutList.style.maxHeight = `${Math.abs(this.popoutToggle.getBoundingClientRect().bottom - this.productGridItem.getBoundingClientRect().bottom)}px`);
                        }
                        t.currentTarget.setAttribute("aria-expanded", !e),
                            this.popoutList.classList.toggle("popout-list--visible"),
                            this.popupListSetDimensions(),
                            this.toggleListPosition(),
                            document.body.addEventListener("click", this.bodyClickEvent);
                    }
                    onPopupToggleFocusout(t) {
                        this.contains(t.relatedTarget) || this._hideList();
                    }
                    onPopupListFocusout(t) {
                        const e = t.currentTarget.contains(t.relatedTarget);
                        this.popoutList.classList.contains("popout-list--visible") && !e && this._hideList();
                    }
                    toggleListPosition() {
                        const t = this.querySelector("[data-popout-toggle]"),
                            e = this.getBoundingClientRect().top + this.clientHeight,
                            i = () => {
                                "true" !== t.getAttribute("aria-expanded") &&
                                    this.popoutList.classList.remove("popout-list--top"),
                                    this.popoutList.removeEventListener("transitionend", i);
                            };
                        "true" === t.getAttribute("aria-expanded")
                            ? window.innerHeight / 2 < e && this.popoutList.classList.add("popout-list--top")
                            : this.popoutList.addEventListener("transitionend", i);
                    }
                    popupListSetDimensions() {
                        this.popoutList.style.setProperty("--max-width", "100vw"),
                            this.popoutList.style.setProperty("--max-height", "100vh"),
                            requestAnimationFrame(() => {
                                this.popoutList.style.setProperty(
                                    "--max-width",
                                    `${parseInt(document.body.clientWidth - this.popoutList.getBoundingClientRect().left)}px`
                                ),
                                    this.popoutList.style.setProperty(
                                        "--max-height",
                                        `${parseInt(document.body.clientHeight - this.popoutList.getBoundingClientRect().top)}px`
                                    );
                            });
                    }
                    popupOptionsClick(t) {
                        if ("#" === t.target.closest("[data-popout-option]").attributes.href.value) {
                            t.preventDefault();
                            const e = t.currentTarget.hasAttribute("data-value")
                                ? t.currentTarget.getAttribute("data-value")
                                : "";
                            this.popoutInput.value = e;
                            const i = t.currentTarget.closest("li");
                            if (i) {
                                const t = i.getAttribute("data-option-value-id"),
                                    e = i.getAttribute("data-product-url");
                                t && this.popoutInput.setAttribute("data-option-value-id", t),
                                    e && this.popoutInput.setAttribute("data-product-url", e);
                            }
                            if (
                                (this.popoutInput.disabled && this.popoutInput.removeAttribute("disabled"),
                                this.fireSubmitEvent)
                            )
                                this._submitForm(e);
                            else {
                                const i = t.currentTarget.parentElement,
                                    s = this.popoutList.querySelector(".is-active"),
                                    o = this.popoutList.querySelector("[aria-current]");
                                this.popoutInput.dispatchEvent(new Event("change", { bubbles: !0 })),
                                    s && (s.classList.remove("is-active"), i.classList.add("is-active")),
                                    "quantity" != this.popoutInput.name ||
                                        i.nextSibling ||
                                        this.classList.add("is-active"),
                                    o &&
                                        o.hasAttribute("aria-current") &&
                                        (o.removeAttribute("aria-current"),
                                        t.currentTarget.setAttribute("aria-current", "true")),
                                    "" !== e &&
                                        this.popoutToggleText &&
                                        ((this.popoutToggleText.textContent = e),
                                        this.popoutToggleText.setAttribute("data-popout-toggle-text", e)),
                                    this.onPopupToggleFocusout(t),
                                    this.onPopupListFocusout(t);
                            }
                        }
                    }
                    onKeyUp(t) {
                        "Escape" === t.code && (this._hideList(), this.popoutToggle.focus());
                    }
                    onBodyClick(t) {
                        const e = this.contains(t.target);
                        this.popoutList.classList.contains("popout-list--visible") && !e && this._hideList();
                    }
                    _connectToggle() {
                        this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
                    }
                    _connectOptions() {
                        this.popoutOptions.length &&
                            this.popoutOptions.forEach((t) => {
                                t.addEventListener("click", (t) => this.popupOptionsClick(t));
                            });
                    }
                    _onFocusOut() {
                        this.addEventListener("keyup", this.keyUpEvent),
                            this.popoutToggle.addEventListener("focusout", this.popupToggleFocusoutEvent),
                            this.popoutList.addEventListener("focusout", this.popupListFocusoutEvent);
                    }
                    _submitForm() {
                        const t = this.closest("form");
                        t && t.submit();
                    }
                    _hideList() {
                        this.popoutList.classList.remove("popout-list--visible"),
                            this.popoutToggle.setAttribute("aria-expanded", !1),
                            this.toggleListPosition(),
                            document.body.removeEventListener("click", this.bodyClickEvent);
                    }
                    constructor() {
                        super();
                    }
                }
            );
    const c = "shopify_recently_viewed";
    function d() {
        var t;
        const e = (function () {
            const t = document.cookie.split("; ").find((t) => t.trim().startsWith(`${c}=`));
            if (!t) return null;
            try {
                return decodeURIComponent(t.split("=").slice(1).join("=").trim());
            } catch {
                return t.split("=").slice(1).join("=").trim();
            }
        })();
        if (!e) return [];
        let i = e.split(" ").filter(Boolean);
        const s =
            null === (t = document.querySelector("[data-product-template]")) || void 0 === t
                ? void 0
                : t.getAttribute("data-product-handle");
        return s && (i = i.filter((t) => t !== s)), i;
    }
    function h(t) {
        const e = new Date();
        e.setDate(e.getDate() + 90);
        const i = encodeURIComponent(t.join(" "));
        document.cookie = `${c}=${i}; expires=${e.toUTCString()}; path=/; domain=${window.location.hostname}`;
    }
    function u(t, e) {
        e = e || {};
        var i = t.tabIndex;
        (t.tabIndex = -1),
            (t.dataset.tabIndex = i),
            t.focus(),
            void 0 !== e.className && t.classList.add(e.className),
            t.addEventListener("blur", function s(o) {
                o.target.removeEventListener(o.type, s),
                    (t.tabIndex = i),
                    delete t.dataset.tabIndex,
                    void 0 !== e.className && t.classList.remove(e.className);
            });
    }
    function m(t) {
        return Array.prototype.slice
            .call(
                t.querySelectorAll(
                    "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
                )
            )
            .filter(function (t) {
                return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
            });
    }
    Shopify.Products = {
        showRecentlyViewed(t = {}) {
            if (Shopify.visualPreviewMode) return;
            const { howManyToShow: e = 4, wrapperId: i = "RecentlyViewed", onComplete: s } = t,
                o = d(),
                n = document.querySelector(`#${i}`);
            if (!o.length || !n) return void (null == s || s());
            const r = Math.min(o.length, e);
            let a = 0;
            !(function t() {
                var e, i;
                if (a >= r) return void (null == s || s());
                const l = o[a],
                    c = `${(null === (e = window.theme) || void 0 === e || null === (i = e.routes) || void 0 === i ? void 0 : i.root) || "/"}products/${encodeURIComponent(l)}?section_id=api-product-grid-item`;
                fetch(c)
                    .then((t) => t.text())
                    .then((e) => {
                        const i = document.createElement("div");
                        i.innerHTML = e;
                        const s = i.querySelector("[data-api-content]");
                        s && n.insertAdjacentHTML("beforeend", s.innerHTML), a++, t();
                    })
                    .catch(() => {
                        h(o.filter((t) => t !== l)), a++, t();
                    });
            })();
        },
        recordRecentlyViewed(t = {}) {
            var e;
            const i =
                null !== (e = t.handle) && void 0 !== e
                    ? e
                    : (function () {
                          const t = decodeURIComponent(window.location.pathname).match(/\/products\/([^/]+)/);
                          return t ? t[1] : null;
                      })();
            if (!i) return;
            let s = d();
            var o;
            (s = s.filter((t) => t !== i)),
                s.unshift(i),
                h(s.slice(0, null !== (o = t.howManyToStoreInMemory) && void 0 !== o ? o : 10));
        },
        clearList() {
            document.cookie = `${c}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${window.location.hostname}`;
        },
        get hasProducts() {
            return d().length > 0;
        },
    };
    var p = {};
    function v() {
        document.removeEventListener("focusin", p.focusin),
            document.removeEventListener("focusout", p.focusout),
            document.removeEventListener("keydown", p.keydown);
    }
    var g = Object.freeze({
        __proto__: null,
        forceFocus: u,
        focusHash: function (t) {
            t = t || {};
            var e = window.location.hash,
                i = document.getElementById(e.slice(1));
            if (i && t.ignore && i.matches(t.ignore)) return !1;
            e && i && u(i, t);
        },
        bindInPageLinks: function (t) {
            return (
                (t = t || {}),
                Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter(function (e) {
                    if ("#" === e.hash || "" === e.hash) return !1;
                    if (t.ignore && e.matches(t.ignore)) return !1;
                    if (((i = e.hash.substr(1)), null === document.getElementById(i))) return !1;
                    var i,
                        s = document.querySelector(e.hash);
                    return (
                        !!s &&
                        (e.addEventListener("click", function () {
                            u(s, t);
                        }),
                        !0)
                    );
                })
            );
        },
        focusable: m,
        trapFocus: function (t, e) {
            e = e || {};
            var i = m(t),
                s = e.elementToFocus || t,
                o = i[0],
                n = i[i.length - 1];
            v(),
                (p.focusin = function (e) {
                    t === e.target || t.contains(e.target) || o.focus(),
                        (e.target !== t && e.target !== n && e.target !== o) ||
                            document.addEventListener("keydown", p.keydown);
                }),
                (p.focusout = function () {
                    document.removeEventListener("keydown", p.keydown);
                }),
                (p.keydown = function (e) {
                    "Tab" === e.code &&
                        (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus()),
                        (e.target !== t && e.target !== o) || !e.shiftKey || (e.preventDefault(), n.focus()));
                }),
                document.addEventListener("focusout", p.focusout),
                document.addEventListener("focusin", p.focusin),
                u(s, e);
        },
        removeTrapFocus: v,
        accessibleLinks: function (t, e) {
            if ("string" != typeof t) throw new TypeError(t + " is not a String.");
            if (0 !== (t = document.querySelectorAll(t)).length) {
                (e = e || {}).messages = e.messages || {};
                var i,
                    s,
                    o,
                    n = {
                        newWindow: e.messages.newWindow || "Opens in a new window.",
                        external: e.messages.external || "Opens external website.",
                        newWindowExternal: e.messages.newWindowExternal || "Opens external website in a new window.",
                    },
                    r = e.prefix || "a11y",
                    a = {
                        newWindow: r + "-new-window-message",
                        external: r + "-external-message",
                        newWindowExternal: r + "-new-window-external-message",
                    };
                t.forEach(function (t) {
                    var e = t.getAttribute("target"),
                        i = t.getAttribute("rel"),
                        s = (function (t) {
                            return t.hostname !== window.location.hostname;
                        })(t),
                        o = "_blank" === e,
                        n = null === i || -1 === i.indexOf("noopener");
                    if (o && n) {
                        var r = null === i ? "noopener" : i + " noopener";
                        t.setAttribute("rel", r);
                    }
                    s && o
                        ? t.setAttribute("aria-describedby", a.newWindowExternal)
                        : s
                          ? t.setAttribute("aria-describedby", a.external)
                          : o && t.setAttribute("aria-describedby", a.newWindow);
                }),
                    (i = n),
                    (s = document.createElement("ul")),
                    (o = Object.keys(i).reduce(function (t, e) {
                        return t + "<li id=" + a[e] + ">" + i[e] + "</li>";
                    }, "")),
                    s.setAttribute("hidden", !0),
                    (s.innerHTML = o),
                    document.body.appendChild(s);
            }
        },
    });
    customElements.get("header-component") ||
        customElements.define(
            "header-component",
            class extends HTMLElement {
                connectedCallback() {
                    this.refreshHeaderHeight(),
                        this.resetHeader(),
                        this.checkTransparentHeader(),
                        this.checkNavigationOverlapping(),
                        this.cartToggleEvent(),
                        this.hideMobileNav(),
                        this.bindings(),
                        this.activeLinks(),
                        document.addEventListener("theme:resize:width", this.checkNavOverlapEvent),
                        document.addEventListener("theme:resize:width", this.checkMobileNavEvent),
                        document.addEventListener("theme:resize:width", this.updateHeaderHeightEvent),
                        document.addEventListener("theme:header:update", this.checkTransparentHeaderEvent),
                        document.addEventListener("shopify:section:select", this.onSectionSelectEvent),
                        this.classList.contains("header--sticky") &&
                            (this.stickyHeaderState(),
                            document.addEventListener("theme:scroll", this.headerStateEvent)),
                        requestAnimationFrame(() => window.dispatchEvent(new Event("resize")));
                }
                cartToggleEvent() {
                    var t;
                    theme.settings.enableAjaxCart &&
                        (null === (t = this.querySelectorAll("[data-cart-toggle]")) ||
                            void 0 === t ||
                            t.forEach((t) => {
                                t.addEventListener("click", (e) => {
                                    const i = document.querySelector("cart-drawer");
                                    i &&
                                        (e.preventDefault(),
                                        i.dispatchEvent(new CustomEvent("theme:cart-drawer:show")),
                                        (window.a11y.lastElement = t));
                                });
                            }));
                }
                stickyHeaderState(t) {
                    const e = window.scrollY,
                        i = t && t.detail && t.detail.up,
                        s = document.querySelector("[data-announcement-wrapper].announcement__wrapper--top"),
                        o = s ? s.offsetHeight : 0,
                        n = this.headerInitialHeight + o,
                        r = this.classList.contains("header--has-scrolled");
                    if (
                        (i && e < 2 * n
                            ? this.classList.add("header--is-hiding")
                            : this.classList.remove("header--is-hiding"),
                        e > n)
                    ) {
                        if (!r) {
                            const t = this.offsetHeight;
                            t > 0 && (this.headerInitialHeight = t);
                        }
                        this.classList.add("header--has-scrolled"), this.classList.remove("header--transparent");
                    } else if (
                        (this.classList.remove("header--has-scrolled"),
                        this.isHeaderTransparent() && this.classList.add("header--transparent"),
                        r)
                    ) {
                        const { headerInitialHeight: t } = window.theme.readHeights();
                        this.headerInitialHeight = t || this.offsetHeight;
                    }
                }
                updateHeaderHeight() {
                    this.refreshHeaderHeight(), this.classList.contains("header--sticky") && this.stickyHeaderState();
                }
                refreshHeaderHeight() {
                    const { headerInitialHeight: t } = window.theme.readHeights();
                    t > 0 && (this.headerInitialHeight = t);
                }
                checkNavigationOverlapping() {
                    this.classList.remove("header--is-hamburger"),
                        this.classList.add("header--is-standard"),
                        (this.getNavigationOverlapping() || theme.isSmall()) &&
                            (this.classList.remove("header--is-standard"), this.classList.add("header--is-hamburger"));
                }
                checkMobileNav() {
                    document.body.classList.contains("nav--is-visible") && theme.isLarge() && this.resetHeader();
                }
                checkTransparentHeader() {
                    this.isHeaderTransparent()
                        ? (document.body.classList.add("has-transparent-header"),
                          this.classList.add("header--transparent"))
                        : (document.body.classList.remove("has-transparent-header"),
                          this.classList.remove("header--transparent"));
                }
                getNavigationOverlapping() {
                    const t = this.querySelector(".wrapper--full-padded > .row"),
                        e = this.querySelector("[data-header-icons]");
                    if (!t || !e) return !0;
                    const i = t.offsetWidth,
                        s = this.getMenuItemsWidth(),
                        o = this.classList,
                        n = o.contains("header--logo-left-links-center"),
                        r = o.contains("header--logo-center-links-left");
                    let a = !1,
                        l = e.offsetWidth,
                        c = this.getLogoWidth();
                    return (
                        n && ((c = c < l ? l : c), (c *= 2), (l = 0)),
                        (a = i < s + c + l + 80),
                        r && c && (a = (i - c) / 2 < s),
                        a
                    );
                }
                getLogoWidth() {
                    const t = this.querySelector("[data-logo-image]"),
                        e = this.querySelector("[data-logo-text]");
                    let i = 0;
                    return (
                        null !== t && (i = parseInt(t.getAttribute("data-width"))),
                        null !== e && (i += e.offsetWidth),
                        i
                    );
                }
                getMenuItemsWidth() {
                    let t = 0;
                    const e = this.querySelector(".nav-standard[data-nav-main]");
                    if (!e) return 0;
                    return (
                        e.querySelectorAll(".menu > .menu-item").forEach((e) => {
                            t += this._outerWidth(e);
                        }),
                        t
                    );
                }
                isHeaderTransparent() {
                    const t = document.querySelector(".main-content").firstElementChild;
                    if (!t) return !1;
                    const e = null == t ? void 0 : t.classList.contains("header--full"),
                        i = null !== (null == t ? void 0 : t.querySelector('[data-header-style="transparent"]'));
                    return "true" === this.getAttribute("data-transparent") && (e || i);
                }
                resetHeader() {
                    const t = this.querySelector("[data-hamburger-icon]");
                    document.body.classList.remove("nav--is-visible"),
                        t.classList.remove("open"),
                        document.body.classList.contains("cart--is-visible") &&
                            document.querySelector("[data-cart-drawer-close]").click(),
                        document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
                }
                bindings() {
                    const t = this.headerSection.querySelectorAll('[data-nav-main] a[href^="#"]'),
                        e = this.navStandard.querySelectorAll("[data-dropdown-parent]"),
                        i = [
                            ...this.headerSection.querySelectorAll("[data-nav-main] [data-collapsible-trigger]"),
                            ...t,
                        ];
                    this.menuToggles.forEach((t) => {
                        t.addEventListener("click", (t) => {
                            t.preventDefault(),
                                t.stopImmediatePropagation(),
                                document.body.classList.contains("nav--is-visible")
                                    ? this.hideMobileNav()
                                    : ((window.a11y.lastElement = t.currentTarget), this.showMobileNav());
                        });
                    }),
                        e.forEach((t) => {
                            const e = t.querySelectorAll("[data-visible-link]");
                            t.addEventListener("mouseenter", () => {
                                theme.touched ||
                                    (t.classList.contains("menu-item--dropdown") ||
                                        this.header.classList.add("header--megamenu-visible"),
                                    t.classList.add("is-expanded"),
                                    e.forEach((t) => {
                                        t.removeAttribute("tabindex"),
                                            t.hasAttribute("aria-expanded") && t.setAttribute("aria-expanded", !0);
                                    }));
                            }),
                                t.addEventListener("mouseleave", () => {
                                    t.classList.contains("menu-item--dropdown") ||
                                        this.header.classList.remove("header--megamenu-visible"),
                                        t.classList.remove("is-expanded"),
                                        e.forEach((t) => {
                                            t.setAttribute("tabindex", "-1"),
                                                t.hasAttribute("aria-expanded") && t.setAttribute("aria-expanded", !1);
                                        });
                                });
                        }),
                        i.forEach((t) => {
                            t.addEventListener("click", () => {
                                t.parentNode.classList.contains("is-expanded")
                                    ? this.submenuClose(t.parentNode)
                                    : this.submenuOpen(t.parentNode);
                            }),
                                t.addEventListener("keyup", (e) => {
                                    "Space" === e.code
                                        ? t.parentNode.classList.contains("is-expanded")
                                            ? this.submenuClose(t.parentNode)
                                            : this.submenuOpen(t.parentNode)
                                        : "Escape" === e.code && this.submenuClose(t.parentNode);
                                });
                        }),
                        document.addEventListener("click", this.documentClick),
                        document.addEventListener("keyup", this.documentKeyup);
                }
                hideOnOutsideClick(t) {
                    const e = this.headerIcons.querySelector("[data-menu-toggle]").contains(t.target),
                        i = document.querySelector("[data-hamburger-scrollable]").parentNode.contains(t.target),
                        s = document.body.classList.contains("nav--is-visible");
                    e || i || !s || this.hideMobileNav();
                }
                hideOnKeyUp(t) {
                    const e = t.code,
                        i = t.target,
                        s = this.headerSection.querySelectorAll("[data-nav-main]")[1],
                        o = this.hamburger.classList.contains("open"),
                        n = document.querySelector("[data-dropdown-parent].is-expanded");
                    ("Tab" !== e && "Escape" !== e) ||
                        ("Tab" === e
                            ? (i.hasAttribute("data-menu-item-link") &&
                                  null !== n &&
                                  n.querySelector("[data-collapsible-trigger]").dispatchEvent(new Event("click")),
                              !s.contains(i) && o && this.hideMobileNav())
                            : "Escape" === e &&
                              (null !== n &&
                                  n.querySelector("[data-collapsible-trigger]").dispatchEvent(new Event("click")),
                              o && this.hideMobileNav()));
                }
                showMobileNav() {
                    const t = this.headerIcons.querySelectorAll("a:not([data-menu-toggle])");
                    document.dispatchEvent(
                        new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.scrollableElement })
                    ),
                        this.hamburger.classList.add("open"),
                        document.body.classList.add("nav--is-visible"),
                        t.forEach((t) => t.setAttribute("tabindex", "-1")),
                        this.hamburgerNavLinks.forEach((t) => t.removeAttribute("tabindex")),
                        this.menuToggles.forEach((t) => t.setAttribute("aria-expanded", !0)),
                        this.mobileNav &&
                            this.a11y.trapFocus(this.mobileNav, {
                                elementToFocus:
                                    this.mobileNav.querySelector(".nav-mobile-close") || this.scrollableElement,
                            });
                }
                hideMobileNav() {
                    const t = this.headerIcons.querySelectorAll("a");
                    document.body.classList.contains("nav--is-visible") &&
                        (this.hamburger.classList.remove("open"),
                        document.body.classList.add("nav--is-hiding"),
                        document.body.classList.remove("nav--is-visible"),
                        this.a11y.removeTrapFocus(),
                        this.scrollLockTimeout && clearTimeout(this.scrollLockTimeout),
                        (this.scrollLockTimeout = setTimeout(() => {
                            document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                                document.body.classList.remove("nav--is-hiding");
                        }, 500)),
                        t.forEach((t) => t.removeAttribute("tabindex")),
                        this.hamburgerNavLinks.forEach((t) => t.setAttribute("tabindex", "-1")),
                        this.menuToggles.forEach((t) => t.setAttribute("aria-expanded", !1)),
                        this.a11y.autoFocusLastElement());
                }
                activeLinks() {
                    const t = this.navStandard.querySelectorAll("[data-menu-item-link]"),
                        e = this.navStandard.querySelectorAll("[data-visible-link]");
                    let i = !1;
                    t.forEach((t) => {
                        t.getAttribute("href") === window.location.pathname &&
                            (t.parentNode.classList.add("is-active"), (i = !0));
                    }),
                        i ||
                            e.forEach((t) => {
                                t.getAttribute("href") === window.location.pathname &&
                                    (t.parentNode.classList.add("is-active"),
                                    t.closest("[data-dropdown-parent]").classList.add("is-active"));
                            });
                }
                submenuClose(t) {
                    t.querySelectorAll("[data-visible-link]").forEach((t) => {
                        t.setAttribute("tabindex", "-1"),
                            t.hasAttribute("aria-expanded") && t.setAttribute("aria-expanded", !1);
                    }),
                        t.classList.contains("menu-item--meganav") &&
                            this.header.classList.remove("header--megamenu-visible");
                }
                submenuOpen(t) {
                    t.querySelectorAll("[data-visible-link]").forEach((t) => {
                        t.removeAttribute("tabindex"),
                            t.hasAttribute("aria-expanded") && t.setAttribute("aria-expanded", !0);
                    }),
                        t.classList.contains("menu-item--meganav") &&
                            this.header.classList.add("header--megamenu-visible");
                }
                disconnectedCallback() {
                    document.removeEventListener("theme:scroll", this.headerStateEvent),
                        document.removeEventListener("theme:resize:width", this.checkNavOverlapEvent),
                        document.removeEventListener("theme:resize:width", this.checkMobileNavEvent),
                        document.removeEventListener("theme:resize:width", this.updateHeaderHeightEvent),
                        document.removeEventListener("theme:header:update", this.checkTransparentHeaderEvent),
                        document.removeEventListener("shopify:section:select", this.onSectionSelectEvent),
                        document.removeEventListener("click", this.documentClick),
                        document.removeEventListener("keyup", this.documentKeyup);
                }
                onSectionSelect() {
                    this.resetHeader();
                }
                _outerWidth(t) {
                    const e = getComputedStyle(t);
                    let i = t.offsetWidth;
                    return (i += parseInt(e.marginLeft) + parseInt(e.marginRight)), i;
                }
                constructor() {
                    super(),
                        (this.headerContainer = this.parentNode),
                        (this.bodyWrap = document.querySelector("[data-body-wrap]")),
                        (this.headerInitialHeight = 0),
                        (this.headerStateEvent = (t) => this.stickyHeaderState(t)),
                        (this.checkMobileNavEvent = () => this.checkMobileNav()),
                        (this.checkNavOverlapEvent = () => this.checkNavigationOverlapping()),
                        (this.checkTransparentHeaderEvent = (t) => this.checkTransparentHeader(t)),
                        (this.updateHeaderHeightEvent = () => this.updateHeaderHeight()),
                        (this.onSectionSelectEvent = this.onSectionSelect.bind(this)),
                        (this.headerSection = this.closest(".shopify-section-header")),
                        (this.header = this.headerSection.querySelector("header-component")),
                        (this.menuToggles = this.headerSection.querySelectorAll("[data-menu-toggle]")),
                        (this.headerIcons = this.header.querySelector("[data-header-icons]")),
                        (this.navStandard = this.header.querySelector("[data-nav-main]")),
                        (this.hamburger = this.header.querySelector("[data-hamburger-icon]")),
                        (this.mobileNav = this.headerSection.querySelector(".nav-hamburger")),
                        (this.scrollableElement = document.querySelector("[data-hamburger-scrollable]")),
                        (this.hamburgerNavLinks = this.scrollableElement.parentNode.querySelectorAll("button, a")),
                        (this.documentClick = (t) => this.hideOnOutsideClick(t)),
                        (this.documentKeyup = (t) => this.hideOnKeyUp(t)),
                        (this.scrollLockTimeout = 0),
                        (this.resetHeight = 0),
                        (this.a11y = g),
                        window.addEventListener("load", this.checkNavOverlapEvent);
                }
            }
        );
    const f = "details",
        b = 'input:not([type="hidden"])',
        y = "[data-popdown]",
        w = "[data-popdown-close]",
        E = "[data-popdown-toggle]",
        L = "has-search-popdown-visible";
    let S = class extends HTMLElement {
        connectedCallback() {
            this.popdownContainer.addEventListener("keyup", (t) => "Escape" === t.code && this.close()),
                this.popdownClose.addEventListener("click", this.close.bind(this)),
                this.popdownToggle.addEventListener("click", this.onPopdownToggleClick.bind(this)),
                this.popdown.addEventListener("transitionend", (t) => {
                    "visibility" == t.propertyName &&
                        this.popdownContainer.hasAttribute("open") &&
                        "false" == this.popdownContainer.getAttribute("open") &&
                        this.closeCallback();
                });
        }
        onPopdownToggleClick(t) {
            t.preventDefault(), t.target.closest(f).hasAttribute("open") ? this.close() : this.open(t);
        }
        onBodyClick(t) {
            this.contains(t.target) || this.close();
        }
        open(t) {
            (this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)),
                t.target.closest(f).setAttribute("open", ""),
                document.body.addEventListener("click", this.onBodyClickEvent),
                document.body.classList.add(L),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.popdown })),
                requestAnimationFrame(() => {
                    t.target.closest(f).setAttribute("open", "true"),
                        this.popdown.addEventListener(
                            "transitionend",
                            (e) => {
                                e.target == this.popdown &&
                                    (this.a11y.trapFocus(this.popdown, {
                                        elementToFocus: this.popdown.querySelector(b),
                                    }),
                                    (theme.a11yTrigger = t.target));
                            },
                            { once: !0 }
                        );
                });
        }
        close() {
            this.popdownContainer.setAttribute("open", "false"),
                document.body.removeEventListener("click", this.onBodyClickEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
        }
        closeCallback() {
            this.popdownContainer.removeAttribute("open"),
                this.a11y.removeTrapFocus(),
                null !== theme.a11yTrigger && theme.a11yTrigger.focus(),
                document.body.classList.remove(L);
        }
        constructor() {
            super(),
                (this.popdown = this.querySelector(y)),
                (this.popdownContainer = this.querySelector(f)),
                (this.popdownToggle = this.querySelector(E)),
                (this.popdownClose = this.querySelector(w)),
                (this.a11y = g);
        }
    };
    customElements.define("header-search-popdown", S);
    const C = {},
        k = {
            forceFocus(t, e) {
                e = e || {};
                var i = t.tabIndex;
                (t.tabIndex = -1),
                    (t.dataset.tabIndex = i),
                    t.focus({ preventScroll: Boolean(e.preventScroll) }),
                    void 0 !== e.className && t.classList.add(e.className),
                    t.addEventListener("blur", function s(o) {
                        o.target.removeEventListener(o.type, s),
                            (t.tabIndex = i),
                            delete t.dataset.tabIndex,
                            void 0 !== e.className && t.classList.remove(e.className);
                    });
            },
            focusHash(t) {
                t = t || {};
                var e = window.location.hash,
                    i = document.getElementById(e.slice(1));
                if (i && t.ignore && i.matches(t.ignore)) return !1;
                e && i && this.forceFocus(i, t);
            },
            bindInPageLinks(t) {
                return (
                    (t = t || {}),
                    Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter((e) => {
                        if ("#" === e.hash || "" === e.hash) return !1;
                        if (t.ignore && e.matches(t.ignore)) return !1;
                        if (((i = e.hash.substr(1)), null === document.getElementById(i))) return !1;
                        var i,
                            s = document.querySelector(e.hash);
                        return (
                            !!s &&
                            (e.addEventListener("click", () => {
                                this.forceFocus(s, t);
                            }),
                            !0)
                        );
                    })
                );
            },
            focusable(t) {
                return Array.prototype.slice
                    .call(
                        t.querySelectorAll(
                            "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
                        )
                    )
                    .filter((t) =>
                        Boolean((t.offsetWidth || t.offsetHeight || t.getClientRects().length) && this.isVisible(t))
                    );
            },
            trapFocus(t, e) {
                e = e || {};
                var i = this.focusable(t),
                    s = e.elementToFocus || t,
                    o = i[0],
                    n = i[i.length - 1],
                    r = Boolean(e.preventScroll);
                this.removeTrapFocus(),
                    (C.focusin = function (e) {
                        t === e.target || t.contains(e.target) || (o && o.focus({ preventScroll: r })),
                            (e.target !== t && e.target !== n && e.target !== o) ||
                                document.addEventListener("keydown", C.keydown);
                    }),
                    (C.focusout = function () {
                        document.removeEventListener("keydown", C.keydown);
                    }),
                    (C.keydown = function (e) {
                        "Tab" === e.code &&
                            (e.target !== n || e.shiftKey || (e.preventDefault(), o.focus({ preventScroll: r })),
                            (e.target !== t && e.target !== o) ||
                                !e.shiftKey ||
                                (e.preventDefault(), n.focus({ preventScroll: r })));
                    }),
                    document.addEventListener("focusout", C.focusout),
                    document.addEventListener("focusin", C.focusin),
                    this.forceFocus(s, e);
            },
            removeTrapFocus() {
                document.removeEventListener("focusin", C.focusin),
                    document.removeEventListener("focusout", C.focusout),
                    document.removeEventListener("keydown", C.keydown);
            },
            autoFocusLastElement() {
                window.a11y.lastElement &&
                    document.body.classList.contains("is-focused") &&
                    setTimeout(() => {
                        var t;
                        null === (t = window.a11y.lastElement) || void 0 === t || t.focus();
                    });
            },
            accessibleLinks(t, e) {
                if ("string" != typeof t) throw new TypeError(t + " is not a String.");
                if (0 !== (t = document.querySelectorAll(t)).length) {
                    (e = e || {}).messages = e.messages || {};
                    var i,
                        s,
                        o,
                        n = {
                            newWindow: e.messages.newWindow || "Opens in a new window.",
                            external: e.messages.external || "Opens external website.",
                            newWindowExternal:
                                e.messages.newWindowExternal || "Opens external website in a new window.",
                        },
                        r = e.prefix || "a11y",
                        a = {
                            newWindow: r + "-new-window-message",
                            external: r + "-external-message",
                            newWindowExternal: r + "-new-window-external-message",
                        };
                    t.forEach((t) => {
                        var e = t.getAttribute("target"),
                            i = t.getAttribute("rel"),
                            s = (function (t) {
                                return t.hostname !== window.location.hostname;
                            })(t),
                            o = "_blank" === e,
                            n = null === i || -1 === i.indexOf("noopener");
                        if (o && n) {
                            var r = null === i ? "noopener" : i + " noopener";
                            t.setAttribute("rel", r);
                        }
                        s && o
                            ? t.setAttribute("aria-describedby", a.newWindowExternal)
                            : s
                              ? t.setAttribute("aria-describedby", a.external)
                              : o && t.setAttribute("aria-describedby", a.newWindow);
                    }),
                        (i = n),
                        (s = document.createElement("ul")),
                        (o = Object.keys(i).reduce((t, e) => t + "<li id=" + a[e] + ">" + i[e] + "</li>", "")),
                        s.setAttribute("hidden", !0),
                        (s.innerHTML = o),
                        document.body.appendChild(s);
                }
            },
            isVisible(t) {
                var e = window.getComputedStyle(t);
                return "none" !== e.display && "hidden" !== e.visibility;
            },
        };
    (window.theme = window.theme || {}),
        (window.theme.a11y = k),
        (window.theme.throttle = (t, e) => {
            let i, s;
            return function o(...n) {
                const r = Date.now();
                (s = clearTimeout(s)),
                    !i || r - i >= e ? (t.apply(null, n), (i = r)) : (s = setTimeout(o.bind(null, ...n), e - (r - i)));
            };
        });
    let A = class extends HTMLElement {
        connectedCallback() {
            this.addEventListener("change", (t) => {
                const e = this.getInputForEventTarget(t.target);
                publish(theme.PUB_SUB_EVENTS.optionValueSelectionChange, {
                    data: { event: t, target: e, selectedOptionValues: this.selectedOptionValues },
                });
            });
        }
        getInputForEventTarget(t) {
            return "SELECT" === t.tagName ? t.selectedOptions[0] : t;
        }
        get selectedOptionValues() {
            return [
                ...Array.from(this.querySelectorAll("select option[selected]")),
                ...Array.from(this.querySelectorAll("fieldset input:checked")),
                ...Array.from(this.querySelectorAll("[data-popout-input]")),
            ]
                .map(({ dataset: t }) => t.optionValueId)
                .filter((t) => Boolean(t));
        }
        constructor() {
            super();
        }
    };
    customElements.define("variant-selects", A);
    window.HTMLUpdateUtility = class t {
        static viewTransition(e, i, s = [], o = []) {
            null == s || s.forEach((t) => t(i));
            const n = document.createElement("div");
            t.setInnerHTML(n, i.outerHTML);
            const r = n.firstChild,
                a = Date.now();
            e.querySelectorAll("[id], [form]").forEach((t) => {
                t.id && (t.id = `${t.id}-${a}`), t.form && t.setAttribute("form", `${t.form.getAttribute("id")}-${a}`);
            }),
                e.parentNode.insertBefore(r, e),
                (e.style.display = "none"),
                null == o || o.forEach((t) => t(r)),
                setTimeout(() => e.remove(), 500);
        }
        static setInnerHTML(t, e) {
            (t.innerHTML = e),
                t.querySelectorAll("script").forEach((t) => {
                    const e = document.createElement("script");
                    Array.from(t.attributes).forEach((t) => {
                        e.setAttribute(t.name, t.value);
                    }),
                        e.appendChild(document.createTextNode(t.innerHTML)),
                        t.parentNode.replaceChild(e, t);
                });
        }
    };
    let T = class extends HTMLElement {
        connectedCallback() {
            this.validateQtyRules(),
                (this.quantityUpdateUnsubscriber = subscribe(
                    theme.PUB_SUB_EVENTS.quantityUpdate,
                    this.validateQtyRules.bind(this)
                ));
        }
        disconnectedCallback() {
            this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
        }
        onInputChange(t) {
            this.validateQtyRules(), this.input && "updates[]" === this.input.name && this.updateCart();
        }
        onButtonClick(t) {
            var e, i;
            t.preventDefault();
            const s = this.input.value,
                o = "BUTTON" === t.target.nodeName ? t.target : t.target.closest("button"),
                n = o ? o.name : void 0,
                r = "decrease" === n || "minus" === n;
            var a, l;
            "increase" === n || "plus" === n
                ? parseInt(
                      null === (a = this.input) || void 0 === a || null === (l = a.dataset) || void 0 === l
                          ? void 0
                          : l.min
                  ) > parseInt(this.input.step) && 0 == this.input.value
                    ? (this.input.value = this.input.dataset.min)
                    : this.input.stepUp()
                : r && this.input.stepDown();
            s !== this.input.value && this.input.dispatchEvent(this.changeEvent),
                (null === (e = this.input) || void 0 === e || null === (i = e.dataset) || void 0 === i
                    ? void 0
                    : i.min) === s &&
                    r &&
                    (this.input.value = parseInt(this.input.min));
        }
        validateQtyRules() {
            const t = parseInt(this.input.value);
            if (this.input.min) {
                const e = this.querySelector("button[name='decrease']");
                e && e.classList.toggle("disabled", parseInt(t) <= parseInt(this.input.min));
            }
            if (this.input.max) {
                const e = parseInt(this.input.max),
                    i = this.querySelector("button[name='increase']");
                i && i.classList.toggle("disabled", t >= e);
            }
        }
        updateCart() {
            this.input &&
                "" !== this.input.value &&
                this.dispatchEvent(
                    new CustomEvent("theme:cart:update", {
                        bubbles: !0,
                        detail: { id: this.input.dataset.id, quantity: this.input.value },
                    })
                );
        }
        constructor() {
            var t, e, i;
            super(),
                (i = void 0),
                (e = "quantityUpdateUnsubscriber") in (t = this)
                    ? Object.defineProperty(t, e, { value: i, enumerable: !0, configurable: !0, writable: !0 })
                    : (t[e] = i),
                (this.input = this.querySelector("input")),
                (this.changeEvent = new Event("change", { bubbles: !0 })),
                this.input.addEventListener("change", this.onInputChange.bind(this)),
                this.querySelectorAll("button").forEach((t) =>
                    t.addEventListener("click", this.onButtonClick.bind(this))
                );
        }
    };
    function q(t) {
        t.querySelectorAll(".form-field").forEach((t) => {
            const e = t.querySelector("label"),
                i = t.querySelector("input, textarea");
            e &&
                i &&
                (i.addEventListener("keyup", (t) => {
                    "" !== t.target.value ? e.classList.add("label--float") : e.classList.remove("label--float");
                }),
                i.value && i.value.length && e.classList.add("label--float"));
        });
    }
    customElements.get("quantity-input") || customElements.define("quantity-input", T);
    let x = window.theme.getWindowWidth(),
        H = window.theme.getWindowHeight();
    let M = window.scrollY,
        F = null,
        D = null,
        I = null,
        P = null,
        B = 0;
    function O(e) {
        setTimeout(() => {
            B && clearTimeout(B),
                t.disablePageScroll(e.detail, { allowTouchMove: (t) => "TEXTAREA" === t.tagName }),
                document.documentElement.setAttribute("data-scroll-locked", "");
        });
    }
    function _(t) {
        const e = t.detail;
        e ? (B = setTimeout(R, e)) : R();
    }
    function R() {
        t.clearQueueScrollLocks(), t.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked");
    }
    const W = (t, e = "", i) => {
        const s = i || document.createElement("div");
        return s.classList.add(e), t.parentNode.insertBefore(s, t), s.appendChild(t);
    };
    function N(t) {
        t.querySelectorAll(".rte table").forEach((t) => {
            W(t, "rte__table-wrapper"), t.setAttribute("data-scroll-lock-scrollable", "");
        });
        t.querySelectorAll(
            '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
        ).forEach((t) => {
            W(t, "rte__video-wrapper");
        });
    }
    function $(t) {
        const e = t.querySelectorAll("[data-aria-toggle]");
        e.length &&
            e.forEach((t) => {
                t.addEventListener("click", function (t) {
                    t.preventDefault();
                    const e = t.currentTarget;
                    e.setAttribute("aria-expanded", "false" == e.getAttribute("aria-expanded") ? "true" : "false");
                    const i = e.getAttribute("aria-controls"),
                        s = document.querySelector(`#${i}`),
                        o = () => {
                            s.classList.remove("expanding"), s.removeEventListener("transitionend", o);
                        },
                        n = () => {
                            s.classList.add("expanding"), s.removeEventListener("transitionstart", n);
                        };
                    s.addEventListener("transitionstart", n),
                        s.addEventListener("transitionend", o),
                        s.classList.toggle("expanded");
                });
            });
    }
    const z = "is-loading",
        U = "img.is-loading";
    const V = "[data-aos]:not(.aos-animate)",
        j = "[data-aos-anchor]",
        K = "[data-aos]:not([data-aos-anchor]):not(.aos-animate)",
        Q = "aos-animate",
        X = { attributes: !1, childList: !0, subtree: !0 };
    let G = [];
    const Y = (t) => {
            for (const e of t)
                if ("childList" === e.type) {
                    const t = e.target,
                        i = t.querySelectorAll(V),
                        s = t.querySelectorAll(j);
                    i.length &&
                        i.forEach((t) => {
                            J.observe(t);
                        }),
                        s.length && tt(s);
                }
        },
        J = new IntersectionObserver(
            (t, e) => {
                t.forEach((t) => {
                    t.isIntersecting && (t.target.classList.add(Q), e.unobserve(t.target));
                });
            },
            { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
        ),
        Z = new IntersectionObserver(
            (t, e) => {
                t.forEach((t) => {
                    if (t.intersectionRatio) {
                        const i = t.target.querySelectorAll(V);
                        i.length &&
                            i.forEach((t) => {
                                t.classList.add(Q);
                            }),
                            e.unobserve(t.target);
                        const s = G.indexOf("#" + t.target.id);
                        -1 !== s && G.splice(s, 1);
                    }
                });
            },
            { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
        );
    function tt(t) {
        t.length &&
            !Shopify.visualPreviewMode &&
            t.forEach((t) => {
                const e = t.dataset.aosAnchor;
                if (e && -1 === G.indexOf(e)) {
                    const t = document.querySelector(e);
                    t && (Z.observe(t), G.push(e));
                }
            });
    }
    (window.requestIdleCallback =
        window.requestIdleCallback ||
        function (t) {
            var e = Date.now();
            return setTimeout(function () {
                t({
                    didTimeout: !1,
                    timeRemaining: function () {
                        return Math.max(0, 50 - (Date.now() - e));
                    },
                });
            }, 1);
        }),
        (window.cancelIdleCallback =
            window.cancelIdleCallback ||
            function (t) {
                clearTimeout(t);
            });
    "true" === document.body.getAttribute("data-animations") &&
        (!(function () {
            const t = document.querySelectorAll(K);
            t.length &&
                t.forEach((t) => {
                    J.observe(t);
                });
        })(),
        (function () {
            const t = document.querySelectorAll(j);
            t.length && tt(t);
        })(),
        new MutationObserver(Y).observe(document.body, X),
        document.addEventListener("shopify:section:unload", (t) => {
            var e;
            if ("object" != typeof t.target || "undefined" === t.target.nodeValue) return;
            const i =
                    "#" + (null === (e = t.target.querySelector("[data-section-id]")) || void 0 === e ? void 0 : e.id),
                s = G.indexOf(i);
            -1 !== s && G.splice(s, 1);
        })),
        window.addEventListener(
            "resize",
            window.theme.debounce(function () {
                document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
                    x !== window.theme.getWindowWidth() &&
                        (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })),
                        (x = window.theme.getWindowWidth())),
                    H !== window.theme.getWindowHeight() &&
                        (document.dispatchEvent(new CustomEvent("theme:resize:height", { bubbles: !0 })),
                        (H = window.theme.getWindowHeight()));
            }, 50)
        ),
        (function () {
            let t;
            window.addEventListener(
                "scroll",
                function () {
                    t && window.cancelAnimationFrame(t),
                        (t = window.requestAnimationFrame(function () {
                            !(function () {
                                const t = window.scrollY;
                                t > M ? ((D = !0), (F = !1)) : t < M ? ((D = !1), (F = !0)) : ((F = null), (D = null)),
                                    (M = t),
                                    document.dispatchEvent(
                                        new CustomEvent("theme:scroll", {
                                            detail: { up: F, down: D, position: t },
                                            bubbles: !1,
                                        })
                                    ),
                                    F &&
                                        !I &&
                                        document.dispatchEvent(
                                            new CustomEvent("theme:scroll:up", { detail: { position: t }, bubbles: !1 })
                                        ),
                                    D &&
                                        !P &&
                                        document.dispatchEvent(
                                            new CustomEvent("theme:scroll:down", {
                                                detail: { position: t },
                                                bubbles: !1,
                                            })
                                        ),
                                    (P = D),
                                    (I = F);
                            })();
                        }));
                },
                { passive: !0 }
            ),
                window.addEventListener("theme:scroll:lock", O),
                window.addEventListener("theme:scroll:unlock", _);
        })(),
        "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
            ? ((document.documentElement.className = document.documentElement.className.replace(
                  "no-touch",
                  "supports-touch"
              )),
              (window.theme.touch = !0))
            : (window.theme.touch = !1),
        document.addEventListener(
            "load",
            (t) => {
                "img" == t.target.tagName.toLowerCase() &&
                    t.target.classList.contains(z) &&
                    (t.target.classList.remove(z),
                    t.target.parentNode.classList.remove(z),
                    t.target.parentNode.parentNode.classList.contains(z) &&
                        t.target.parentNode.parentNode.classList.remove(z));
            },
            !0
        ),
        window.addEventListener("DOMContentLoaded", () => {
            q(document),
                $(document),
                N(document),
                document.querySelectorAll(U).forEach((t) => {
                    t.complete &&
                        (t.classList.remove(z),
                        t.parentNode.classList.remove(z),
                        t.parentNode.parentNode.classList.contains(z) && t.parentNode.parentNode.classList.remove(z));
                });
        }),
        document.addEventListener("shopify:section:load", (t) => {
            const e = t.target;
            "object" == typeof e &&
                "undefined" !== e.nodeValue &&
                (q(e),
                N(e),
                $(document),
                document.dispatchEvent(new CustomEvent("theme:header:update", { bubbles: !0 })));
        }),
        document.addEventListener("shopify:section:reorder", () => {
            document.dispatchEvent(new CustomEvent("theme:header:update", { bubbles: !0 }));
        }),
        document.addEventListener("shopify:section:unload", () => {
            setTimeout(() => {
                document.dispatchEvent(new CustomEvent("theme:header:update", { bubbles: !0 }));
            }, 200);
        });
    const et = "is-focused",
        it = "[data-skip-content]",
        st = 'a[href="#"]';
    function ot(t) {
        (this.status = t.status || null),
            (this.headers = t.headers || null),
            (this.json = t.json || null),
            (this.body = t.body || null);
    }
    (window.a11y = new (class {
        init() {
            (this.a11y = window.theme.a11y),
                (this.html = document.documentElement),
                (this.body = document.body),
                (this.inPageLink = document.querySelector(it)),
                (this.linkesWithOnlyHash = document.querySelectorAll(st)),
                this.a11y.focusHash(),
                this.a11y.bindInPageLinks(),
                this.clickEvents(),
                this.focusEvents();
        }
        clickEvents() {
            this.inPageLink &&
                this.inPageLink.addEventListener("click", (t) => {
                    t.preventDefault();
                }),
                this.linkesWithOnlyHash &&
                    this.linkesWithOnlyHash.forEach((t) => {
                        t.addEventListener("click", (t) => {
                            t.preventDefault();
                        });
                    });
        }
        focusEvents() {
            document.addEventListener("mousedown", () => {
                this.body.classList.remove(et);
            }),
                document.addEventListener("keyup", (t) => {
                    "Tab" === t.code && this.body.classList.add(et);
                });
        }
        constructor() {
            this.init();
        }
    })()),
        (window.theme.waitForAnimationEnd = function (t) {
            return new Promise((e) => {
                null == t ||
                    t.addEventListener("animationend", function i(s) {
                        s.target == t && (t.removeEventListener("animationend", i), e());
                    });
            });
        }),
        (ot.prototype = Error.prototype);
    const nt = "is-added",
        rt = "is-disabled",
        at = "is-empty",
        lt = "is-hidden",
        ct = "is-loading",
        dt = "is-open",
        ht = "is-success",
        ut = "is-visible",
        mt = "is-expanded",
        pt = "is-updated",
        vt = "variant--soldout",
        gt = "variant--unavailable",
        ft = "cartToggle--empty",
        bt = {
            apiContent: "[data-api-content]",
            apiLineItems: "[data-api-line-items]",
            apiCartPrice: "[data-api-cart-price]",
            cartBarAdd: "[data-cart-bar-add-to-cart]",
            cartCloseError: "[data-cart-error-close]",
            cartDrawer: "cart-drawer",
            cartDrawerClose: "[data-cart-drawer-close]",
            cartEmpty: "[data-cart-empty]",
            cartErrors: "[data-cart-errors]",
            cartItemRemove: "[data-item-remove]",
            cartMessage: "[data-cart-message]",
            cartPage: "[data-cart-page]",
            cartForm: "[data-cart-form]",
            cartTermsCheckbox: "[data-cart-acceptance-checkbox]",
            cartCheckoutButtonWrapper: "[data-cart-checkout-buttons]",
            cartCheckoutButton: "[data-cart-checkout-button]",
            cartItemsCount: "[data-cart-items-count]",
            cartToggle: "[data-cart-toggle]",
            cartTotal: "[data-cart-total]",
            checkoutButtons: "[data-checkout-buttons]",
            emptyMessage: "[data-empty-message]",
            errorMessage: "[data-error-message]",
            formCloseError: "[data-close-error]",
            formErrorsContainer: "[data-cart-errors-container]",
            formWrapper: "[data-form-wrapper]",
            freeShipping: "[data-cart-message]",
            freeShippingProgress: "[data-cart-progress]",
            headerWrapper: "[data-header-wrapper]",
            item: "[data-item]",
            itemsHolder: "[data-items-holder]",
            leftToSpend: "[data-left-to-spend]",
            navDrawer: "[data-drawer]",
            outerSection: "[data-section-id]",
            priceHolder: "[data-cart-price-holder]",
            quickAddHolder: "[data-quick-add-holder]",
            quickAddModal: "[data-quick-add-modal]",
            qtyInput: 'input[name="updates[]"]',
            termsErrorMessage: "[data-terms-error-message]",
            collapsibleBody: "[data-collapsible-body]",
            discountInput: "[data-discount-input]",
            discountField: "[data-discount-field]",
            discountButton: "[data-apply-discount]",
            discountBody: "[data-discount-body]",
            discountCode: "[data-discount-code]",
            discountErrorMessage: "[data-discount-error-message]",
            removeDiscount: "[data-remove-discount]",
        },
        yt = "data-cart-total",
        wt = "disabled",
        Et = "data-cart-message",
        Lt = "data-cart-total-price",
        St = "data-limit",
        Ct = "data-item",
        kt = "data-item-index",
        At = "data-item-title",
        Tt = "data-scroll-locked",
        qt = "data-max-inventory-reached",
        xt = "data-error-message-position";
    let Ht = class extends HTMLElement {
        connectedCallback() {
            if (
                ((this.cartPage = document.querySelector(bt.cartPage)),
                (this.cartForm = document.querySelector(bt.cartForm)),
                (this.cartDrawer = document.querySelector(bt.cartDrawer)),
                (this.cartEmpty = document.querySelector(bt.cartEmpty)),
                (this.cartItemsCount = document.querySelector(bt.cartItemsCount)),
                (this.cartTermsCheckbox = document.querySelector(bt.cartTermsCheckbox)),
                (this.cartCheckoutButtonWrapper = document.querySelector(bt.cartCheckoutButtonWrapper)),
                (this.cartCheckoutButton = document.querySelector(bt.cartCheckoutButton)),
                (this.checkoutButtons = document.querySelector(bt.checkoutButtons)),
                (this.itemsHolder = document.querySelector(bt.itemsHolder)),
                (this.priceHolder = document.querySelector(bt.priceHolder)),
                (this.items = document.querySelectorAll(bt.item)),
                (this.cartTotal = document.querySelector(bt.cartTotal)),
                (this.freeShipping = document.querySelectorAll(bt.freeShipping)),
                (this.cartErrorHolder = document.querySelector(bt.cartErrors)),
                (this.cartCloseErrorMessage = document.querySelector(bt.cartCloseError)),
                (this.headerWrapper = document.querySelector(bt.headerWrapper)),
                (this.navDrawer = document.querySelector(bt.navDrawer)),
                (this.subtotal = window.theme.subtotal),
                (this.discountInput = document.querySelector(bt.discountInput)),
                (this.discountField = document.querySelector(bt.discountField)),
                (this.discountButton = document.querySelector(bt.discountButton)),
                (this.hasDiscountBlock = Boolean(document.querySelector(bt.discountButton))),
                (this.discountErrorMessage = document.querySelector(bt.discountErrorMessage)),
                (this.existingDiscountCodes = []),
                (this.discounts = document.querySelectorAll(bt.discountBody)),
                (this.emptyMessage = document.querySelector(bt.emptyMessage)),
                (this.cartToggle = document.querySelector(bt.cartToggle)),
                (this.cartMessage = document.querySelector(bt.cartMessage)),
                (this.cart = this.cartDrawer || this.cartPage),
                this.hasDiscountBlock &&
                    (this.discountButton.addEventListener("click", (t) => {
                        t.preventDefault();
                        const e = this.discountInput.value.trim();
                        (this.discountInput.value = ""), e && this.applyDiscount(e);
                    }),
                    this.bindDiscountEventListeners()),
                (this.addToCart = this.addToCart.bind(this)),
                (this.cartAddEvent = this.cartAddEvent.bind(this)),
                (this.updateProgress = this.updateProgress.bind(this)),
                (this.onCartDrawerClose = this.onCartDrawerClose.bind(this)),
                (this.onCartRefresh = this.getCart.bind(this)),
                document.addEventListener("theme:cart:add", this.cartAddEvent),
                document.addEventListener("theme:announcement:init", this.updateProgress),
                theme.settings.enableAjaxCart ||
                    document.addEventListener("theme:cart-drawer:close", this.onCartDrawerClose),
                this.cartMessage)
            ) {
                this.cartFreeLimitShipping = Number(this.cartMessage.getAttribute(St)) * window.Shopify.currency.rate;
                const t = this.cartMessage.getAttribute(Lt);
                null !== t && (this.subtotal = Number(t)), this.updateProgress();
            }
            (this.circumference = 28 * Math.PI),
                (this.freeShippingLimit = this.freeShipping.length
                    ? Number(this.freeShipping[0].getAttribute(St)) * window.Shopify.currency.rate
                    : 0),
                this.freeShippingMessageHandle(this.subtotal),
                this.updateProgress(),
                (this.build = this.build.bind(this)),
                (this.updateCart = this.updateCart.bind(this)),
                (this.productAddCallback = this.productAddCallback.bind(this)),
                (this.formSubmitHandler = window.theme.throttle(this.formSubmitHandler.bind(this), 50)),
                this.cart &&
                    ((this.hasItemsInCart = this.hasItemsInCart.bind(this)),
                    (this.cartCount = this.getCartItemCount())),
                (this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this)),
                (this.totalItems = this.items.length),
                (this.showCannotAddMoreInCart = !1),
                (this.cartUpdateFailed = !1),
                (this.discountError = !1),
                this.cartEvents(),
                this.cartRemoveEvents(),
                this.cartUpdateEvents(),
                document.addEventListener("theme:product:add", this.productAddCallback),
                document.addEventListener("theme:product:add-error", this.productAddCallback),
                document.addEventListener("theme:cart:refresh", this.onCartRefresh);
        }
        disconnectedCallback() {
            document.removeEventListener("theme:cart:add", this.cartAddEvent),
                document.removeEventListener("theme:cart:refresh", this.onCartRefresh),
                document.removeEventListener("theme:announcement:init", this.updateProgress),
                document.removeEventListener("theme:product:add", this.productAddCallback),
                document.removeEventListener("theme:product:add-error", this.productAddCallback),
                document.documentElement.hasAttribute(Tt) &&
                    document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
        }
        onCartDrawerClose() {
            var t, e, i, s, o;
            (null === (t = this.cartDrawer) || void 0 === t ? void 0 : t.classList.contains(dt)) &&
                (null === (s = this.cart) || void 0 === s || s.classList.remove(pt));
            (null === (e = this.cartEmpty) || void 0 === e || e.classList.remove(pt),
            null === (i = this.cartErrorHolder) || void 0 === i || i.classList.remove(mt),
            this.hasDiscountBlock) &&
                (null === (o = this.discountErrorMessage) || void 0 === o || o.classList.add("hidden"));
        }
        cartUpdateEvents() {
            (this.items = document.querySelectorAll(bt.item)),
                this.items.forEach((t) => {
                    t.addEventListener("theme:cart:update", (e) => {
                        this.updateCart({ id: e.detail.id, quantity: e.detail.quantity }, t);
                    });
                });
        }
        cartRemoveEvents() {
            document.querySelectorAll(bt.cartItemRemove).forEach((t) => {
                const e = t.closest(bt.item);
                t.addEventListener("click", (i) => {
                    i.preventDefault(),
                        t.classList.contains(rt) || this.updateCart({ id: t.dataset.id, quantity: 0 }, e);
                });
            }),
                this.cartCloseErrorMessage &&
                    this.cartCloseErrorMessage.addEventListener("click", (t) => {
                        var e;
                        t.preventDefault(),
                            null === (e = this.cartErrorHolder) || void 0 === e || e.classList.remove(mt);
                    });
        }
        cartAddEvent(t) {
            let e = "",
                i = t.detail.button;
            if (i.hasAttribute("disabled")) return;
            const s = i.form || i.closest("form");
            if (!s.checkValidity()) return void s.reportValidity();
            if (((e = new FormData(s)), null !== s && s.querySelector('[type="file"]'))) return;
            theme.settings.enableAjaxCart && this.cartDrawer && t.preventDefault();
            const o = s.getAttribute(qt),
                n = s.getAttribute(xt);
            (this.showCannotAddMoreInCart = !1),
                "true" === o && "cart" === n && (this.showCannotAddMoreInCart = !0),
                this.addToCart(e, i);
        }
        bindDiscountEventListeners() {
            this.hasDiscountBlock &&
                ((this.discounts = document.querySelectorAll(bt.discountBody)),
                this.discounts.forEach((t) => {
                    const e = t.dataset.discountCode;
                    this.existingDiscountCodes.includes(e) || this.existingDiscountCodes.push(e);
                    const i = t.querySelector(bt.removeDiscount);
                    i &&
                        (i.removeEventListener("click", this.handleRemoveDiscount),
                        i.addEventListener("click", (t) => {
                            t.preventDefault(), this.removeDiscount(e);
                        }));
                }));
        }
        applyDiscount(t) {
            if (this.existingDiscountCodes.includes(t))
                return (
                    this.discountErrorMessage.classList.remove("hidden"),
                    void (this.discountErrorMessage.textContent = window.theme.strings.discount_already_applied)
                );
            this.existingDiscountCodes.push(t), this.updateCartDiscounts(this.existingDiscountCodes.join(","));
        }
        removeDiscount(t) {
            this.existingDiscountCodes.includes(t) &&
                ((this.existingDiscountCodes = this.existingDiscountCodes.filter((e) => e !== t)),
                this.updateCartDiscounts(this.existingDiscountCodes.join(",")));
        }
        updateCartDiscounts(t) {
            var e;
            const i =
                null ===
                    (e = t
                        .split(",")
                        .filter((t) => t)
                        .pop()) || void 0 === e
                    ? void 0
                    : e.trim();
            this.disableCartButtons(),
                this.discountErrorMessage.classList.add("hidden"),
                fetch(window.theme.routes.cart_update_url, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", Accept: "application/json" },
                    body: JSON.stringify({ discount: t }),
                })
                    .then((t) => {
                        if (!t.ok) throw new Error(`HTTP error! status: ${t.status}`);
                        return t.text();
                    })
                    .then((t) => {
                        let e;
                        try {
                            e = JSON.parse(t);
                        } catch (e) {
                            throw (
                                (console.error("Failed to parse cart update response:", t),
                                new Error("Invalid JSON response from server."))
                            );
                        }
                        if (i) {
                            e.discount_codes &&
                            Array.isArray(e.discount_codes) &&
                            e.discount_codes.some((t) => t.code === i && t.applicable)
                                ? (this.discountError = !1)
                                : ((this.discountError = !0),
                                  (this.existingDiscountCodes = this.existingDiscountCodes.filter((t) => t !== i)));
                        } else this.discountError = !1;
                        this.getCart();
                    })
                    .catch((t) => {
                        console.error(t);
                    });
        }
        cartEvents() {
            this.cartTermsCheckbox &&
                (this.cartTermsCheckbox.removeEventListener("change", this.formSubmitHandler),
                this.cartCheckoutButtonWrapper.removeEventListener("click", this.formSubmitHandler),
                this.cartForm.removeEventListener("submit", this.formSubmitHandler),
                this.cartTermsCheckbox.addEventListener("change", this.formSubmitHandler),
                this.cartCheckoutButtonWrapper.addEventListener("click", this.formSubmitHandler),
                this.cartForm.addEventListener("submit", this.formSubmitHandler));
        }
        formSubmitHandler() {
            const t = document.querySelector(bt.cartTermsCheckbox),
                e = document.querySelector(bt.termsErrorMessage),
                i = Boolean(null == t ? void 0 : t.checked);
            if (e && this.cartCheckoutButton)
                if (i) e.classList.remove(mt), this.cartCheckoutButton.removeAttribute(wt);
                else {
                    if (e.classList.contains(mt)) return;
                    (e.innerText = theme.strings.cartAcceptanceError),
                        this.cartCheckoutButton.setAttribute(wt, !0),
                        e.classList.add(mt);
                }
        }
        formErrorsEvents(t) {
            const e = t.querySelector(bt.formCloseError);
            null == e ||
                e.addEventListener("click", (e) => {
                    e.preventDefault(), t && t.classList.remove(ut);
                });
        }
        getCart() {
            this.cart &&
                fetch(theme.routes.cart_url + "?section_id=api-cart-items")
                    .then(this.cartErrorsHandler)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = document.createElement("div");
                        e.innerHTML = t;
                        const i = e.querySelector(bt.apiContent);
                        this.build(i);
                    })
                    .catch((t) => console.error(t));
        }
        addToCart(t, e) {
            var i, s;
            this.cart && this.cart.classList.add(ct);
            const o = null == e ? void 0 : e.closest(bt.quickAddHolder),
                n =
                    (null ===
                        (s =
                            null === (i = null == e ? void 0 : e.closest("product-form")) || void 0 === i
                                ? void 0
                                : i.querySelector('input[name="quantity"]')) || void 0 === s
                        ? void 0
                        : s.value) || 1;
            e && (e.classList.add(ct), (e.disabled = !0)),
                o && o.classList.add(ut),
                fetch(theme.routes.cart_add_url, {
                    method: "POST",
                    headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/javascript" },
                    body: t,
                })
                    .then((t) => t.json())
                    .then((t) => {
                        (t.status &&
                            (this.addToCartError(t, e),
                            e &&
                                (e.classList.remove(ct),
                                (e.disabled = !1),
                                e.dispatchEvent(
                                    new CustomEvent("theme:product:add-error", {
                                        detail: { response: t, button: e, quantity: n },
                                        bubbles: !0,
                                    })
                                )),
                            !this.showCannotAddMoreInCart)) ||
                            (this.cart
                                ? (e &&
                                      (e.classList.remove(ct),
                                      e.classList.add(nt),
                                      e.dispatchEvent(
                                          new CustomEvent("theme:product:add", {
                                              detail: { response: t, button: e, quantity: n },
                                              bubbles: !0,
                                          })
                                      )),
                                  theme.settings.enableAjaxCart || (window.location = theme.routes.cart_url),
                                  this.getCart())
                                : (window.location = theme.routes.cart_url));
                    })
                    .catch((t) => {
                        this.addToCartError(t, e), this.enableCartButtons();
                    });
        }
        updateCart(t = {}, e = null) {
            this.cart.classList.add(ct), this.disableCartButtons();
            const i = this.cart.querySelector(`[${Ct}="${t.id}"]`) || e,
                s = (null == i ? void 0 : i.hasAttribute(kt)) ? parseInt(i.getAttribute(kt)) : 0,
                o = (null == i ? void 0 : i.hasAttribute(At)) ? i.getAttribute(At) : null;
            if (0 === s) return;
            const n = { line: s, quantity: t.quantity };
            fetch(theme.routes.cart_change_url, {
                method: "post",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify(n),
            })
                .then((t) => t.text())
                .then((t) => {
                    if (JSON.parse(t).errors)
                        return (
                            (this.cartUpdateFailed = !0),
                            this.updateErrorText(o),
                            this.toggleErrorMessage(),
                            this.resetLineItem(e),
                            this.enableCartButtons(),
                            void this.bindDiscountEventListeners()
                        );
                    this.getCart();
                })
                .catch((t) => {
                    console.error(t), this.enableCartButtons();
                });
        }
        resetLineItem(t) {
            const e = t.querySelector(bt.qtyInput),
                i = e.getAttribute("value");
            e.value = i;
        }
        disableCartButtons() {
            if (!this.cart) return;
            const t = this.cart.querySelectorAll("input"),
                e = this.cart.querySelectorAll(`button, ${bt.cartItemRemove}`);
            t.length &&
                t.forEach((t) => {
                    t.classList.add(rt), t.blur(), (t.disabled = !0);
                }),
                e.length &&
                    e.forEach((t) => {
                        t.setAttribute(wt, !0);
                    });
        }
        enableCartButtons() {
            if (!this.cart) return;
            const t = this.cart.querySelectorAll("input"),
                e = this.cart.querySelectorAll(`button, ${bt.cartItemRemove}`);
            t.length &&
                t.forEach((t) => {
                    t.classList.remove(rt), (t.disabled = !1);
                }),
                e.length &&
                    e.forEach((t) => {
                        t.removeAttribute(wt);
                    }),
                this.cart.classList.remove(ct);
        }
        updateErrorText(t) {
            this.cartErrorHolder.querySelector(bt.errorMessage).innerText = t;
        }
        toggleErrorMessage() {
            this.cartErrorHolder &&
                (this.cartErrorHolder.classList.toggle(mt, this.cartUpdateFailed || this.showCannotAddMoreInCart),
                (this.showCannotAddMoreInCart = !1),
                (this.cartUpdateFailed = !1));
        }
        cartErrorsHandler(t) {
            return t.ok
                ? t
                : t.json().then(function (e) {
                      throw new ot({ status: t.statusText, headers: t.headers, json: e });
                  });
        }
        hideAddToCartErrorMessage() {
            const t = this.button.closest(bt.productForm),
                e = null == t ? void 0 : t.querySelector(bt.formErrorsContainer);
            null == e || e.classList.remove(ut);
        }
        addToCartError(t, e) {
            var i;
            if (this.showCannotAddMoreInCart) return;
            if (null !== e) {
                const i = e.closest(bt.outerSection) || e.closest(bt.quickAddHolder) || e.closest(bt.quickAddModal);
                let s = null == i ? void 0 : i.querySelector(bt.formErrorsContainer);
                if (s) {
                    let e = `${t.message}: ${t.description}`;
                    t.message == t.description && (e = t.message),
                        (s.innerHTML = `<div class="errors">${e}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close-thin" viewBox="0 0 27 27"><path d="M.5.5l26 26M26.5.5l-26 26"></path></svg></button></div>`),
                        s.classList.add(ut),
                        this.formErrorsEvents(s);
                }
                e.dispatchEvent(
                    new CustomEvent("theme:product:add-error", { detail: { response: t, button: e }, bubbles: !0 })
                ),
                    this.getCart();
            }
            const s = null == e ? void 0 : e.closest(bt.quickAddHolder);
            s &&
                s.dispatchEvent(
                    new CustomEvent("theme:cart:error", {
                        bubbles: !0,
                        detail: { message: t.message, description: t.description, holder: s },
                    })
                ),
                null === (i = this.cart) || void 0 === i || i.classList.remove(ct);
        }
        productAddCallback(t) {
            let e = [],
                i = null;
            const s = "theme:product:add-error" == t.type,
                o = t.detail.button,
                n = document.querySelector(bt.cartBarAdd);
            e.push(o),
                (i = o.closest(bt.quickAddHolder)),
                n && e.push(n),
                e.forEach((t) => {
                    t.classList.remove(ct), s || t.classList.add(nt);
                }),
                setTimeout(() => {
                    e.forEach((t) => {
                        var e, i;
                        t.classList.remove(nt);
                        (null === (e = t.closest(bt.formWrapper)) || void 0 === e
                            ? void 0
                            : e.classList.contains(vt)) ||
                            (null === (i = t.closest(bt.formWrapper)) || void 0 === i
                                ? void 0
                                : i.classList.contains(gt)) ||
                            (t.disabled = !1);
                    }),
                        null == i || i.classList.remove(ut);
                }, 1e3);
        }
        toggleClassesOnContainers() {
            const t = this.hasItemsInCart();
            this.cartToggle.classList.toggle(ft, !t),
                this.emptyMessage.classList.toggle(lt, t),
                this.cart.classList.toggle(at, !t),
                !t &&
                    this.cartDrawer &&
                    setTimeout(() => {
                        this.a11y.trapFocus(this.cartDrawer, {
                            elementToFocus: this.cartDrawer.querySelector(bt.cartDrawerClose),
                        });
                    }, 100);
        }
        build(t) {
            var e;
            const i = t.querySelector(bt.apiLineItems),
                s = Boolean(null === i),
                o = t.querySelector(bt.apiCartPrice),
                n = t.querySelector(bt.cartTotal);
            this.priceHolder && o && (this.priceHolder.innerHTML = o.innerHTML),
                (this.itemsHolder.innerHTML = s ? t.innerHTML : i.innerHTML),
                (this.newTotalItems = i && i.querySelectorAll(bt.item).length ? i.querySelectorAll(bt.item).length : 0),
                (this.subtotal = n && n.hasAttribute(yt) ? parseInt(n.getAttribute(yt)) : 0),
                (this.cartCount = this.getCartItemCount()),
                document.dispatchEvent(
                    new CustomEvent("theme:cart:change", { bubbles: !0, detail: { cartCount: this.cartCount } })
                );
            const r = this.getCartItemCount();
            this.cartItemsCount &&
                (r > 0 && this.newTotalItems > 0
                    ? (this.cartItemsCount.innerText = r < 10 ? r : "9+")
                    : (this.cartItemsCount.innerText = "0")),
                (this.cartTotal.innerHTML =
                    0 === this.subtotal
                        ? window.theme.strings.free
                        : window.theme.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)),
                this.totalItems !== this.newTotalItems &&
                    ((this.totalItems = this.newTotalItems), this.toggleClassesOnContainers()),
                (null === (e = this.cartDrawer) || void 0 === e ? void 0 : e.classList.contains(dt)) &&
                    this.cart.classList.add(pt),
                this.cart.classList.remove(ct),
                this.hasDiscountBlock &&
                    (this.discountField && (this.discountField.value = this.existingDiscountCodes.join(",")),
                    this.discountError
                        ? ((this.discountErrorMessage.textContent = window.theme.strings.discount_not_applicable),
                          this.discountErrorMessage.classList.remove("hidden"))
                        : this.discountErrorMessage.classList.add("hidden")),
                this.freeShippingMessageHandle(this.subtotal),
                this.cartRemoveEvents(),
                this.cartUpdateEvents(),
                this.toggleErrorMessage(),
                this.enableCartButtons(),
                this.updateProgress(),
                this.bindDiscountEventListeners(),
                this.cartToggle &&
                    this.hasItemsInCart() &&
                    (this.cartToggle.classList.add(nt),
                    window.theme.waitForAnimationEnd(this.cartItemsCount).then(() => {
                        var t;
                        null === (t = this.cartToggle) || void 0 === t || t.classList.remove(nt);
                    })),
                document.dispatchEvent(new CustomEvent("theme:product:added", { bubbles: !0 }));
        }
        getCartItemCount() {
            return Array.from(this.cart.querySelectorAll(bt.qtyInput)).reduce((t, e) => t + parseInt(e.value), 0);
        }
        hasItemsInCart() {
            return this.totalItems > 0;
        }
        freeShippingMessageHandle(t) {
            this.freeShipping.length &&
                this.freeShipping.forEach((e) => {
                    const i = e.hasAttribute(Et) && "true" === e.getAttribute(Et) && t >= 0;
                    e.classList.toggle(ht, i && t >= this.freeShippingLimit);
                });
        }
        updateProgress() {
            if (((this.freeShipping = document.querySelectorAll(bt.freeShipping)), !this.freeShipping.length)) return;
            const t = this.freeShippingLimit > 0 ? this.subtotal / this.freeShippingLimit : 0,
                e = Math.max(0, Math.min(100 * t, 100)),
                i = Math.max(0, this.freeShippingLimit - this.subtotal),
                s = window.theme.formatMoney(i, theme.moneyFormat);
            this.freeShipping.forEach((t) => {
                const i = t.querySelector(bt.freeShippingProgress),
                    o = t.querySelector(bt.leftToSpend);
                o && (o.innerHTML = s.replace(".00", "")),
                    i && (i.setAttribute("data-percent", `${e}`), i.style.setProperty("--percent", `${e}`));
            });
        }
        constructor() {
            super(), (this.a11y = window.theme.a11y);
        }
    };
    customElements.get("cart-items") || customElements.define("cart-items", Ht);
    let Mt = class extends HTMLElement {
        connectedCallback() {
            (window.theme.hasCartDrawer = !0),
                this.addEventListener("theme:cart-drawer:show", this.openCartDrawer),
                document.addEventListener("theme:cart:toggle", this.toggleCartDrawer),
                document.addEventListener("theme:quick-add:open", this.closeCartDrawer),
                document.addEventListener("theme:product:added", this.openCartDrawerOnProductAdded);
        }
        disconnectedCallback() {
            document.removeEventListener("theme:product:added", this.openCartDrawerOnProductAdded),
                document.removeEventListener("theme:cart:toggle", this.toggleCartDrawer),
                document.removeEventListener("theme:quick-add:open", this.closeCartDrawer),
                document.querySelectorAll("cart-drawer").length <= 1 && (window.theme.hasCartDrawer = !1),
                (function () {
                    if (document.querySelector("cart-items")) return;
                    const t = document.createElement("cart-items");
                    document.body.appendChild(t);
                })();
        }
        openCartDrawerOnProductAdded() {
            theme.settings.enableAjaxCart &&
                "popover" !== theme.settings.cartAddFeedback &&
                (this.cartDrawerIsOpen || this.openCartDrawer());
        }
        openCartDrawer() {
            this.cartDrawerIsOpen ||
                ((this.cartDrawerIsOpen = !0),
                (this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)),
                document.body.addEventListener("click", this.onBodyClickEvent),
                document.dispatchEvent(
                    new CustomEvent("theme:cart-drawer:open", { detail: { target: this }, bubbles: !0 })
                ),
                document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.cartScroll })),
                this.classList.add("is-open"),
                this.setAttribute("aria-hidden", "false"),
                this.observeAdditionalCheckoutButtons(),
                window.theme.waitForAnimationEnd(this.cartDrawerInner).then(() => {
                    this.a11y.trapFocus(this, { elementToFocus: this.querySelector("[data-cart-drawer-close]") });
                }));
        }
        closeCartDrawer() {
            this.classList.contains("is-open") &&
                (this.classList.remove("is-open"),
                this.setAttribute("aria-hidden", "true"),
                (this.cartDrawerIsOpen = !1),
                document.dispatchEvent(new CustomEvent("theme:cart-drawer:close", { bubbles: !0 })),
                this.a11y.removeTrapFocus(),
                this.a11y.autoFocusLastElement(),
                document.body.removeEventListener("click", this.onBodyClickEvent),
                document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })));
        }
        toggleCartDrawer() {
            this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
        }
        closeCartEvents() {
            this.cartDrawerClose.addEventListener("click", (t) => {
                t.preventDefault(), this.closeCartDrawer();
            }),
                this.addEventListener("keyup", (t) => {
                    "Escape" === t.code && this.closeCartDrawer();
                });
        }
        onBodyClick(t) {
            t.target.hasAttribute("data-drawer-underlay") && this.closeCartDrawer();
        }
        observeAdditionalCheckoutButtons() {
            const t = this.querySelector(".additional-checkout-buttons");
            if (t) {
                const e = new MutationObserver(() => {
                    this.a11y.trapFocus(this, { elementToFocus: this.querySelector("[data-cart-drawer-close]") }),
                        e.disconnect();
                });
                e.observe(t, { subtree: !0, childList: !0 });
            }
        }
        constructor() {
            super(),
                (this.cartDrawerIsOpen = !1),
                (this.cartDrawerClose = this.querySelector("[data-cart-drawer-close]")),
                (this.cartDrawerInner = this.querySelector("[data-cart-drawer-inner]")),
                (this.openCartDrawer = this.openCartDrawer.bind(this)),
                (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
                (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
                (this.openCartDrawerOnProductAdded = this.openCartDrawerOnProductAdded.bind(this)),
                (this.cartDrawerSection = this.closest(".shopify-section")),
                (this.cartScroll = document.querySelector("[data-cart-scroll]")),
                (this.a11y = window.theme.a11y),
                this.closeCartEvents();
        }
    };
    customElements.get("cart-drawer") || customElements.define("cart-drawer", Mt);
    let Ft = class extends HTMLElement {
        connectedCallback() {
            (this.popoverHolder = this.querySelector("[data-popover]")),
                (this.popoverTemplate = this.querySelector("[data-popover-template]")),
                this.popoverHolder.addEventListener("click", () => {
                    const t = document.querySelector("cart-drawer");
                    t && t.dispatchEvent(new CustomEvent("theme:cart-drawer:show"));
                });
        }
        disconnectedCallback() {
            document.removeEventListener("theme:product:add", this.showPopoverOnProductAdd),
                document.removeEventListener("theme:product:add-error", this.showPopoverOnProductAdd);
        }
        renderPopover(t, e) {
            const i = document.importNode(this.popoverTemplate.content, !0),
                s = i.querySelector("[data-popover-heading]"),
                o = i.querySelector("[data-popover-image]"),
                n = i.querySelector("[data-popover-title]"),
                r = i.querySelector("[data-popover-variant]"),
                a = i.querySelector("[data-popover-selling-plan]"),
                l = i.querySelector("[data-popover-item-props]"),
                c = i.querySelector("[data-popover-item-price]"),
                d = i.querySelector("[data-popover-unit-price]");
            if (t.status) {
                const e = i.querySelector(".popover-inner");
                e.classList.add("errors"), (e.textContent = null != t.message ? String(t.message) : "");
            } else {
                var h;
                const i = t,
                    m = /(<([^>]+)>)/gi,
                    p = i.title.replace(m, "");
                let v =
                    0 === i.final_price
                        ? window.theme.strings.free
                        : window.theme.formatMoney(i.final_price, theme.settings.moneyFormat);
                const g = (null === (h = i.featured_image) || void 0 === h ? void 0 : h.url) || theme.assets.no_image;
                let f = "";
                const b = i.selling_plan_allocation ? i.selling_plan_allocation.selling_plan.name : null;
                if (
                    (i.unit_price_measurement &&
                        ((f = `${window.theme.formatMoney(i.unit_price, theme.moneyWithoutCurrencyFormat)} / `),
                        1 != i.unit_price_measurement.reference_value &&
                            (f += i.unit_price_measurement.reference_value),
                        (f += i.unit_price_measurement.reference_unit)),
                    i.properties)
                )
                    for (const t in i.properties)
                        if ({}.hasOwnProperty.call(i.properties, t)) {
                            const e = i.properties[t],
                                s = t.slice(0, 1);
                            if (e && "_" !== s) {
                                const i = document.createElement("p");
                                (i.textContent = `${t}: ${String(e)}`), l.appendChild(i);
                            }
                        }
                const y = s.textContent;
                s.textContent = `(${e}) ${p} ${y}`;
                const w = document.createElement("img");
                var u;
                g !== theme.assets.no_image
                    ? ((w.src = `${g}&width=240`),
                      (w.alt = p),
                      (w.width = 120),
                      (w.height = 120),
                      (w.sizes = "120px"),
                      (w.srcset = `${g}&width=120 1x, ${g}&width=180 1.5x, ${g}&width=240 2x`))
                    : (w.src = g),
                    o.appendChild(w),
                    (n.textContent = p),
                    (r.textContent = i.product_has_only_default_variant
                        ? ""
                        : String(null !== (u = i.variant_title) && void 0 !== u ? u : "")),
                    (a.textContent = b ? String(b) : ""),
                    (c.textContent = v),
                    (d.textContent = f);
            }
            const m = document.createElement("div");
            m.appendChild(i);
            const p = m.innerHTML;
            return m.remove(), p;
        }
        showPopover(t) {
            if (!theme.settings.enableAjaxCart || "popover" !== theme.settings.cartAddFeedback) return;
            const e = t.detail.response,
                i = t.detail.quantity;
            theme.isMobile() ||
                ((this.popoverHolder.innerHTML = this.renderPopover(e, i)),
                this.popoverHolder.classList.toggle("is-error", Boolean(e.status)),
                this.popoverHolder.classList.add("is-visible"),
                clearTimeout(this.popoverTimer),
                (this.popoverTimer = setTimeout(() => {
                    this.hidePopover();
                }, 3e3)));
        }
        hidePopover() {
            this.popoverHolder.classList.remove("is-visible", "is-error"),
                setTimeout(() => {
                    this.popoverHolder.innerHTML = "";
                }, 300);
        }
        constructor() {
            super(),
                (this.popoverTimer = ""),
                (this.showPopoverOnProductAdd = this.showPopover.bind(this)),
                document.addEventListener("theme:product:add", this.showPopoverOnProductAdd),
                document.addEventListener("theme:product:add-error", this.showPopoverOnProductAdd);
        }
    };
    customElements.get("cart-popover") || customElements.define("cart-popover", Ft);
    const Dt = 'input[type="search"]',
        It = '[aria-selected="true"] a',
        Pt = 'button[type="reset"]',
        Bt = "hidden";
    let Ot = class extends HTMLElement {
        toggleResetButton() {
            const t = this.resetButton.classList.contains(Bt);
            this.input.value.length > 0 && t
                ? this.resetButton.classList.remove(Bt)
                : 0 !== this.input.value.length || t || this.resetButton.classList.add(Bt);
        }
        onChange() {
            this.toggleResetButton();
        }
        shouldResetForm() {
            return !document.querySelector(It);
        }
        onFormReset(t) {
            t.preventDefault(),
                this.shouldResetForm() &&
                    ((this.input.value = ""), this.toggleResetButton(), t.target.querySelector(Dt).focus());
        }
        constructor() {
            super(),
                (this.input = this.querySelector(Dt)),
                (this.resetButton = this.querySelector(Pt)),
                this.input &&
                    (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
                    this.input.addEventListener(
                        "input",
                        window.theme
                            .debounce((t) => {
                                this.onChange(t);
                            }, 300)
                            .bind(this)
                    ));
        }
    };
    customElements.define("header-search-form", Ot);
    const _t = '[role="option"]',
        Rt = '[aria-selected="true"]',
        Wt = "a, button, input, select, textarea, [tabindex]",
        Nt = "predictive-search",
        $t = "[data-predictive-search-results]",
        zt = "[data-predictive-search-status]",
        Ut = 'input[type="search"]',
        Vt = "[data-popdown]",
        jt = "[data-predictive-search-live-region-count-value]",
        Kt = "data-search-results-groups-wrapper",
        Qt = "[data-predictive-search-search-for-text]",
        Xt = "#shopify-section-predictive-search",
        Gt = '[aria-selected="true"] a',
        Yt = '[aria-selected="true"] a, button[aria-selected="true"]';
    customElements.define(
        "predictive-search",
        class extends Ot {
            connectedCallback() {
                this.input.addEventListener("focus", this.onFocus.bind(this)),
                    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
                    this.addEventListener("focusout", this.onFocusOut.bind(this)),
                    this.addEventListener("keyup", this.onKeyup.bind(this)),
                    this.addEventListener("keydown", this.onKeydown.bind(this)),
                    this.predictiveSearchResults.addEventListener("mousedown", this.onResultsMousedown.bind(this));
            }
            onResultsMousedown(t) {
                t.target.closest(Wt) || t.preventDefault();
            }
            getQuery() {
                return this.input.value.trim();
            }
            onChange() {
                super.onChange();
                const t = this.getQuery();
                var e;
                (this.searchTerm && t.startsWith(this.searchTerm)) ||
                    null === (e = this.querySelector(Kt)) ||
                    void 0 === e ||
                    e.remove();
                this.updateSearchForTerm(this.searchTerm, t),
                    (this.searchTerm = t),
                    this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.reset();
            }
            onFormSubmit(t) {
                (this.getQuery().length && !this.querySelector(Gt)) || t.preventDefault();
            }
            onFormReset(t) {
                super.onFormReset(t),
                    super.shouldResetForm() &&
                        ((this.searchTerm = ""),
                        this.abortController.abort(),
                        (this.abortController = new AbortController()),
                        this.closeResults(!0));
            }
            shouldResetForm() {
                return !document.querySelector(Gt);
            }
            onFocus() {
                const t = this.getQuery();
                t.length &&
                    (this.searchTerm !== t
                        ? this.onChange()
                        : "true" === this.getAttribute("results")
                          ? this.open()
                          : this.getSearchResults(this.searchTerm));
            }
            onFocusOut() {
                setTimeout(() => {
                    this.contains(document.activeElement) || this.close();
                });
            }
            onKeyup(t) {
                switch ((this.getQuery().length || this.close(!0), t.preventDefault(), t.code)) {
                    case "ArrowUp":
                        this.switchOption("up");
                        break;
                    case "ArrowDown":
                        this.switchOption("down");
                        break;
                    case "Enter":
                        this.selectOption();
                }
            }
            onKeydown(t) {
                ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
            }
            updateSearchForTerm(t, e) {
                const i = this.querySelector(Qt),
                    s = null == i ? void 0 : i.innerText;
                if (s) {
                    var o;
                    if ((null === (o = s.match(new RegExp(t, "g"))) || void 0 === o ? void 0 : o.length) > 1) return;
                    const n = s.replace(t, e);
                    i.innerText = n;
                }
            }
            switchOption(t) {
                if (!this.getAttribute("open")) return;
                const e = "up" === t,
                    i = this.querySelector(Rt),
                    s = Array.from(this.querySelectorAll(_t)).filter((t) => null !== t.offsetParent);
                let o = 0;
                if (e && !i) return;
                let n = -1,
                    r = 0;
                for (; -1 === n && r <= s.length; ) s[r] === i && (n = r), r++;
                if (
                    ((this.statusElement.textContent = ""),
                    !e && i ? (o = n === s.length - 1 ? 0 : n + 1) : e && (o = 0 === n ? s.length - 1 : n - 1),
                    o === n)
                )
                    return;
                const a = s[o];
                a.setAttribute("aria-selected", !0),
                    i && i.setAttribute("aria-selected", !1),
                    this.input.setAttribute("aria-activedescendant", a.id);
            }
            selectOption() {
                const t = this.querySelector(Yt);
                t && t.click();
            }
            getSearchResults(t) {
                const e = t.replace(" ", "-").toLowerCase();
                this.setLiveRegionLoadingState(),
                    this.cachedResults[e]
                        ? this.renderSearchResults(this.cachedResults[e])
                        : fetch(
                              `${theme.routes.predictive_search_url}?q=${encodeURIComponent(t)}&section_id=predictive-search`,
                              { signal: this.abortController.signal }
                          )
                              .then((t) => {
                                  if (!t.ok) {
                                      var e = new Error(t.status);
                                      throw (this.close(), e);
                                  }
                                  return t.text();
                              })
                              .then((t) => {
                                  const i = new DOMParser().parseFromString(t, "text/html").querySelector(Xt).innerHTML;
                                  this.allPredictiveSearchInstances.forEach((t) => {
                                      t.cachedResults[e] = i;
                                  }),
                                      this.renderSearchResults(i);
                              })
                              .catch((t) => {
                                  if (20 !== (null == t ? void 0 : t.code)) throw (this.close(), t);
                              });
            }
            setLiveRegionLoadingState() {
                (this.statusElement = this.statusElement || this.querySelector(zt)),
                    (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")),
                    this.setLiveRegionText(this.loadingText),
                    this.setAttribute("loading", !0);
            }
            setLiveRegionText(t) {
                this.statusElement.setAttribute("aria-hidden", "false"),
                    (this.statusElement.textContent = t),
                    setTimeout(() => {
                        this.statusElement.setAttribute("aria-hidden", "true");
                    }, 1e3);
            }
            renderSearchResults(t) {
                (this.predictiveSearchResults.innerHTML = t),
                    this.setAttribute("results", !0),
                    this.setLiveRegionResults(),
                    this.open();
            }
            setLiveRegionResults() {
                this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector(jt).textContent);
            }
            getResultsMaxHeight() {
                return (
                    (this.resultsMaxHeight =
                        window.theme.getWindowHeight() - document.querySelector(Vt).getBoundingClientRect().bottom),
                    this.resultsMaxHeight
                );
            }
            open() {
                (this.predictiveSearchResults.style.maxHeight =
                    this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`),
                    this.setAttribute("open", !0),
                    this.input.setAttribute("aria-expanded", !0),
                    (this.isOpen = !0);
            }
            close(t = !1) {
                this.closeResults(t), (this.isOpen = !1);
            }
            closeResults(t = !1) {
                var e;
                t && ((this.input.value = ""), this.removeAttribute("results"));
                const i = this.querySelector(Rt);
                i && i.setAttribute("aria-selected", !1),
                    this.input.setAttribute("aria-activedescendant", ""),
                    this.removeAttribute("loading"),
                    this.removeAttribute("open"),
                    this.input.setAttribute("aria-expanded", !1),
                    (this.resultsMaxHeight = !1),
                    null === (e = this.predictiveSearchResults) || void 0 === e || e.removeAttribute("style");
            }
            reset() {
                (this.predictiveSearchResults.innerHTML = ""), (this.input.val = ""), this.a11y.removeTrapFocus();
            }
            constructor() {
                super(),
                    (this.a11y = g),
                    (this.abortController = new AbortController()),
                    (this.allPredictiveSearchInstances = document.querySelectorAll(Nt)),
                    (this.cachedResults = {}),
                    (this.input = this.querySelector(Ut)),
                    (this.isOpen = !1),
                    (this.predictiveSearchResults = this.querySelector($t)),
                    (this.searchPopdown = this.closest(Vt)),
                    (this.searchTerm = "");
            }
        }
    );
    const Jt = (t, e = void 0) => {
        document.dispatchEvent(new CustomEvent(t, { bubbles: !0, detail: e }));
    };
    let Zt = class extends HTMLElement {
            connectedCallback() {
                (this.content = this.querySelector("[data-quickview-content]")),
                    (this.dialog = this.querySelector("[data-quickview-dialog]")),
                    this.content &&
                        this.dialog &&
                        (this.addEventListener("click", this.onClick),
                        this.addEventListener("theme:product:add", this.onProductAddSuccess),
                        this.addDialogEvents(),
                        this.addGlobalEvents());
            }
            disconnectedCallback() {
                this.removeEventListener("click", this.onClick),
                    this.removeEventListener("theme:product:add", this.onProductAddSuccess),
                    this.removeDialogEvents(),
                    this.removeGlobalEvents(),
                    this.disconnectResizeObserver(),
                    this.abortFetchRequest(),
                    this.clearCloseFinalizeTimer(),
                    this.clearAllLoading();
            }
            addDialogEvents() {
                this.dialog.addEventListener("click", this.onDialogClick),
                    this.dialog.addEventListener("close", this.onDialogClose),
                    this.dialog.addEventListener("animationend", this.onDialogAnimationEnd),
                    document.addEventListener("keydown", this.onKeyDown);
            }
            removeDialogEvents() {
                var t, e, i;
                null === (t = this.dialog) || void 0 === t || t.removeEventListener("click", this.onDialogClick),
                    null === (e = this.dialog) || void 0 === e || e.removeEventListener("close", this.onDialogClose),
                    null === (i = this.dialog) ||
                        void 0 === i ||
                        i.removeEventListener("animationend", this.onDialogAnimationEnd),
                    document.removeEventListener("keydown", this.onKeyDown);
            }
            addGlobalEvents() {
                document.addEventListener("theme:quickview:close", this.onQuickviewClose);
            }
            removeGlobalEvents() {
                document.removeEventListener("theme:quickview:close", this.onQuickviewClose);
            }
            openFromTrigger(t) {
                const e = null == t ? void 0 : t.getAttribute("data-trigger-quickview");
                if (!t || !e || this.loadingButtonsByHandle.has(e)) return;
                const i = this.getLoadingButtons(t, e);
                if (
                    (i.forEach((t) => t.classList.add("is-loading")),
                    this.loadingButtonsByHandle.set(e, i),
                    this.isOpen && this.activeHandle === e)
                )
                    return this.modalClose(), void this.resetLoading(e);
                (this.activeTrigger = t), this.renderModal(e);
            }
            getLoadingButtons(t, e) {
                const i = t.closest("[data-product-block]"),
                    s = null == i ? void 0 : i.querySelectorAll(`[data-trigger-quickview="${e}"]`);
                return (null == s ? void 0 : s.length) ? Array.from(s) : [t];
            }
            async renderModal(t) {
                this.abortFetchRequest(),
                    this.classList.add("is-loading"),
                    (this.abortController = new AbortController());
                try {
                    const e = await this.fetchModalSection(t),
                        i = this.extractApiContent(e);
                    this.applyApiContent(i, t),
                        Jt("theme:quickview:loaded", { handle: this.activeHandle, trigger: this.activeTrigger });
                } catch (e) {
                    if ("AbortError" === e.name) return;
                    console.error("Quick View error:", e),
                        Jt("theme:quickview:failed", { handle: t, trigger: this.activeTrigger });
                } finally {
                    this.classList.remove("is-loading"), (this.abortController = null), this.resetLoading(t);
                }
            }
            fetchModalSection(t) {
                return fetch(`${theme.routes.root}products/${t}?section_id=api-quickview`, {
                    signal: this.abortController.signal,
                }).then((t) => {
                    if (!t.ok) throw new Error(`Quick View request failed: ${t.status}`);
                    return t.text();
                });
            }
            extractApiContent(t) {
                const e = document.createElement("div");
                e.innerHTML = t;
                const i = e.querySelector("[data-api-content]");
                if (!i) throw new Error("Quick View content missing");
                return i;
            }
            applyApiContent(t, e) {
                (this.content.innerHTML = t.innerHTML),
                    (this.content.scrollTop = 0),
                    (this.activeHandle = e),
                    this.modalCreatedCallback();
            }
            modalCreatedCallback() {
                this.initPaymentButton(), this.modalOpen(), this.observeContentResize();
            }
            modalOpen() {
                if (this.isOpen)
                    return (
                        this.dialog.hasAttribute("closing") &&
                            (this.clearCloseFinalizeTimer(),
                            this.dialog.removeAttribute("closing"),
                            (this.isAnimating = !1)),
                        this.resetTrapFocus(),
                        void this.syncScrollableState()
                    );
                const e = window.scrollY;
                (document.documentElement.style.overflowAnchor = "none"),
                    t.disablePageScroll(this.content),
                    document.documentElement.setAttribute("data-scroll-locked", ""),
                    "function" != typeof this.dialog.show || this.dialog.open
                        ? this.dialog.hasAttribute("open") || this.dialog.setAttribute("open", "")
                        : this.dialog.show(),
                    this.setOpenState(),
                    (this.isAnimating = !0),
                    this.resetTrapFocus(),
                    window.scrollTo(0, e),
                    setTimeout(() => {
                        document.documentElement.style.overflowAnchor = "";
                    });
            }
            modalClose() {
                if (this.isOpen && !this.isAnimating) {
                    if (!this.dialog.hasAttribute("closing"))
                        return (
                            this.dialog.setAttribute("closing", ""),
                            (this.isAnimating = !0),
                            void this.startCloseFinalizeTimer()
                        );
                    this.setClosedState(),
                        this.content.classList.remove("is-scrollable"),
                        (this.content.scrollTop = 0),
                        this.disconnectResizeObserver(),
                        this.a11y.removeTrapFocus(),
                        Jt("theme:scroll:unlock"),
                        this.autoFocusLastElement(),
                        this.dispatchQuickviewClosed(),
                        this.resetLoading(this.activeHandle),
                        (this.activeHandle = ""),
                        (this.activeTrigger = null),
                        "function" == typeof this.dialog.close && this.dialog.open
                            ? this.dialog.close()
                            : this.dialog.removeAttribute("open"),
                        window.setTimeout(() => {
                            this.isOpen || (this.content.innerHTML = "");
                        }, 350);
                }
            }
            setOpenState() {
                this.clearCloseFinalizeTimer(),
                    this.dialog.removeAttribute("closing"),
                    (this.isAnimating = !1),
                    (this.isOpen = !0),
                    this.setAttribute("aria-hidden", "false"),
                    this.classList.add("is-open"),
                    document.documentElement.setAttribute("data-quickview-open", "");
            }
            setClosedState() {
                this.clearCloseFinalizeTimer(),
                    (this.isOpen = !1),
                    this.classList.remove("is-open"),
                    this.setAttribute("aria-hidden", "true"),
                    document.documentElement.removeAttribute("data-quickview-open"),
                    this.dialog.removeAttribute("closing");
            }
            onQuickviewClose() {
                this.requestClose();
            }
            onProductAddSuccess(t) {
                var e;
                if (!this.isOpen) return;
                const i = null === (e = t.detail) || void 0 === e ? void 0 : e.button;
                i && this.contains(i) && this.modalClose();
            }
            onClick(t) {
                t.target.closest("[data-quickview-close]") && this.requestClose(t);
            }
            onKeyDown(t) {
                "Escape" === t.key && this.isOpen && (t.preventDefault(), this.requestClose());
            }
            onDialogClick(t) {
                t.target === this.dialog && this.requestClose();
            }
            onDialogClose() {
                this.isOpen && this.requestClose();
            }
            onDialogAnimationEnd(t) {
                if (t.target === this.dialog) {
                    if (((this.isAnimating = !1), this.dialog.hasAttribute("closing") && this.isOpen))
                        return this.clearCloseFinalizeTimer(), void this.modalClose();
                    this.resetTrapFocus(), this.syncScrollableState();
                }
            }
            requestClose(t = null) {
                null == t || t.preventDefault(), this.modalClose();
            }
            autoFocusLastElement() {
                if (this.activeTrigger && document.body.contains(this.activeTrigger))
                    return void this.activeTrigger.focus();
                if (!this.activeHandle) return;
                const t = document.querySelector(`[data-trigger-quickview="${this.activeHandle}"]`);
                null == t || t.focus();
            }
            dispatchQuickviewClosed() {
                Jt("theme:quickview:closed", { handle: this.activeHandle, trigger: this.activeTrigger });
            }
            resetTrapFocus() {
                const t = this.querySelector("[data-quickview-close]");
                this.a11y.removeTrapFocus(),
                    this.a11y.trapFocus(this.content, { elementToFocus: t || this.content, preventScroll: !0 });
            }
            resetLoading(t) {
                if (!t) return;
                const e = this.loadingButtonsByHandle.get(t);
                (null == e ? void 0 : e.length) && e.forEach((t) => t.classList.remove("is-loading")),
                    this.loadingButtonsByHandle.delete(t);
            }
            clearAllLoading() {
                this.loadingButtonsByHandle.forEach((t) => {
                    t.forEach((t) => t.classList.remove("is-loading"));
                }),
                    this.loadingButtonsByHandle.clear();
            }
            abortFetchRequest() {
                this.abortController && this.abortController.abort();
            }
            initPaymentButton() {
                const t = theme.settings.enablePaymentButton,
                    e = theme.settings.enableAcceptTerms;
                t &&
                    !e &&
                    "undefined" != typeof Shopify &&
                    void 0 !== Shopify.PaymentButton &&
                    void 0 !== Shopify.PaymentButton.init &&
                    Shopify.PaymentButton.init();
            }
            syncScrollableState() {
                if (this.isAnimating) return;
                const t = this.content.firstElementChild;
                if (!t) return void this.content.classList.remove("is-scrollable");
                const e = t.getBoundingClientRect().height,
                    i = this.content.getBoundingClientRect().height;
                if (!i) return void this.content.classList.remove("is-scrollable");
                const s = e - i;
                this.content.classList.toggle("is-scrollable", s > 1);
            }
            observeContentResize() {
                this.disconnectResizeObserver();
                const t = this.content.firstElementChild;
                t &&
                    "undefined" != typeof ResizeObserver &&
                    ((this.resizeObserver = new ResizeObserver(this.syncScrollableState)),
                    this.resizeObserver.observe(t),
                    this.resizeObserver.observe(this.content));
            }
            disconnectResizeObserver() {
                var t;
                null === (t = this.resizeObserver) || void 0 === t || t.disconnect(), (this.resizeObserver = null);
            }
            startCloseFinalizeTimer() {
                this.clearCloseFinalizeTimer(),
                    (this.closeFinalizeTimer = window.setTimeout(() => {
                        var t;
                        (null === (t = this.dialog) || void 0 === t ? void 0 : t.hasAttribute("closing")) &&
                            this.isOpen &&
                            ((this.isAnimating = !1), this.modalClose());
                    }, 400));
            }
            clearCloseFinalizeTimer() {
                this.closeFinalizeTimer &&
                    (window.clearTimeout(this.closeFinalizeTimer), (this.closeFinalizeTimer = null));
            }
            constructor() {
                super(),
                    (this.a11y = window.theme.a11y),
                    (this.activeHandle = ""),
                    (this.activeTrigger = null),
                    (this.abortController = null),
                    (this.isOpen = !1),
                    (this.isAnimating = !1),
                    (this.closeFinalizeTimer = null),
                    (this.loadingButtonsByHandle = new Map()),
                    (this.resizeObserver = null),
                    (this.onQuickviewClose = this.onQuickviewClose.bind(this)),
                    (this.onProductAddSuccess = this.onProductAddSuccess.bind(this)),
                    (this.onClick = this.onClick.bind(this)),
                    (this.onKeyDown = this.onKeyDown.bind(this)),
                    (this.onDialogClick = this.onDialogClick.bind(this)),
                    (this.onDialogClose = this.onDialogClose.bind(this)),
                    (this.onDialogAnimationEnd = this.onDialogAnimationEnd.bind(this)),
                    (this.syncScrollableState = this.syncScrollableState.bind(this));
            }
        },
        te = class extends HTMLElement {
            connectedCallback() {
                this.bindButton();
            }
            bindButton() {
                var t;
                null === (t = this.button) || void 0 === t || t.removeEventListener("click", this.onClick),
                    (this.button = this.querySelector("[data-trigger-quickview]")),
                    this.button && this.button.addEventListener("click", this.onClick);
            }
            disconnectedCallback() {
                var t;
                null === (t = this.button) || void 0 === t || t.removeEventListener("click", this.onClick);
            }
            onClick(t) {
                t.preventDefault();
                const e = document.querySelector("[data-quickview-modal]");
                null == e || e.openFromTrigger(this.button);
            }
            constructor() {
                super(), (this.onClick = this.onClick.bind(this));
            }
        };
    customElements.get("quickview-modal") || customElements.define("quickview-modal", Zt),
        customElements.get("quickview-trigger") || customElements.define("quickview-trigger", te);
    const ee = "[data-product-image]",
        ie = "video",
        se = '[data-host="vimeo"]',
        oe = '[data-host="youtube"]';
    let ne = class extends HTMLElement {
        connectedCallback() {
            (this.trigger = this.closest(ee) || this),
                this.trigger.addEventListener("mouseenter", this.mouseEnterEvent),
                this.trigger.addEventListener("mouseleave", this.mouseLeaveEvent);
        }
        disconnectedCallback() {
            this.trigger &&
                (this.trigger.removeEventListener("mouseenter", this.mouseEnterEvent),
                this.trigger.removeEventListener("mouseleave", this.mouseLeaveEvent));
        }
        mouseActions(t) {
            (this.hovered = t), this.videoActions();
        }
        videoActions() {
            const t = this.querySelector(oe),
                e = this.querySelector(se),
                i = t || e,
                s = this.querySelector(ie);
            if (i) {
                let t = this.hovered ? "playVideo" : "pauseVideo",
                    s = `{"event":"command","func":"${t}","args":""}`;
                e && ((t = this.hovered ? "play" : "pause"), (s = `{"method":"${t}"}`)),
                    i.contentWindow && i.contentWindow.postMessage(s, "*"),
                    this.iframeReady || i.addEventListener("load", this.onIframeLoad, { once: !0 });
            } else if (s)
                if (this.hovered) {
                    const t = s.play();
                    t && "function" == typeof t.catch && t.catch(() => {});
                } else s.pause(), (s.currentTime = 0);
        }
        constructor() {
            super(),
                (this.hovered = !1),
                (this.trigger = null),
                (this.iframeReady = !1),
                (this.mouseEnterEvent = () => this.mouseActions(!0)),
                (this.mouseLeaveEvent = () => this.mouseActions(!1)),
                (this.onIframeLoad = () => {
                    (this.iframeReady = !0), this.videoActions();
                });
        }
    };
    customElements.get("hover-images") || customElements.define("hover-images", ne),
        (window.theme.scrollTo = (t) => {
            const e = document.querySelector(".header-sticky")
                ? document.querySelector("[data-header-height]").offsetHeight
                : 0;
            window.scrollTo({ top: t + window.scrollY - e, left: 0, behavior: "smooth" });
        }),
        customElements.get("tooltip-component") ||
            customElements.define(
                "tooltip-component",
                class extends HTMLElement {
                    connectedCallback() {
                        if (!document.querySelector(".tooltip-default")) {
                            const t =
                                    '<div class="tooltip-default__arrow"></div><div class="tooltip-default__inner"><div class="tooltip-default__text"></div></div>',
                                e = document.createElement("div");
                            (e.className = "tooltip-default"), (e.innerHTML = t), document.body.appendChild(e);
                        }
                        this.addEventListener("mouseenter", this.addPinMouseEvent),
                            this.addEventListener("mouseleave", this.removePinMouseEvent),
                            this.addEventListener("pointerleave", this.removePinMouseEvent),
                            this.addEventListener("focusin", this.addPinMouseEvent),
                            this.addEventListener("focusout", this.removePinMouseEvent),
                            this.addEventListener("theme:tooltip:init", this.addPinEvent),
                            document.addEventListener("theme:tooltip:close", this.removePinEvent),
                            (this.onVariantChangeUnsubscriber = subscribe(
                                theme.PUB_SUB_EVENTS.optionValueSelectionChange,
                                this.removePin.bind(this, !0, !1)
                            ));
                    }
                    addPin(t = !1) {
                        const e = document.querySelector(".tooltip-default");
                        if (this.label && e && ((t && !this.hasAttribute("data-tooltip-stop-mouseenter")) || !t)) {
                            const t = e.querySelector(".tooltip-default__arrow"),
                                i = e.querySelector(".tooltip-default__inner");
                            e.querySelector(".tooltip-default__text").innerHTML = this.label;
                            const s = i.offsetWidth,
                                o = this.getBoundingClientRect(),
                                n = o.top,
                                r = o.width,
                                a = n + o.height + window.scrollY;
                            let l = o.left - s / 2 + r / 2;
                            const c = 24,
                                d = l + s - window.theme.getWindowWidth() + c;
                            d > 0 && (l -= d),
                                l < 0 && (l = 0),
                                (t.style.left = `${o.left + r / 2}px`),
                                e.style.setProperty("--tooltip-top", `${a}px`),
                                (i.style.transform = `translateX(${l}px)`),
                                e.classList.remove("is-hiding"),
                                e.classList.add("is-visible"),
                                document.addEventListener("theme:scroll", this.removePinEvent);
                        }
                    }
                    removePin(t, e = !1, i = !1) {
                        const s = document.querySelector(".tooltip-default"),
                            o = s.classList.contains("is-visible");
                        s &&
                            ((e && !this.hasAttribute("data-tooltip-stop-mouseenter")) || !e) &&
                            (o &&
                                (i || (t && t.detail && t.detail.hideTransition)) &&
                                (s.classList.add("is-hiding"),
                                this.hideTransitionTimeout && clearTimeout(this.hideTransitionTimeout),
                                (this.hideTransitionTimeout = setTimeout(() => {
                                    s.classList.remove("is-hiding");
                                }, this.transitionSpeed))),
                            s.classList.remove("is-visible"),
                            document.removeEventListener("theme:scroll", this.removePinEvent));
                    }
                    disconnectedCallback() {
                        this.onVariantChangeUnsubscriber(),
                            document.removeEventListener("theme:tooltip:close", this.removePinEvent),
                            document.removeEventListener("theme:scroll", this.removePinEvent);
                    }
                    constructor() {
                        super(),
                            (this.label = this.hasAttribute("data-tooltip") ? this.getAttribute("data-tooltip") : ""),
                            (this.transitionSpeed = 200),
                            (this.hideTransitionTimeout = 0),
                            (this.addPinEvent = () => this.addPin()),
                            (this.addPinMouseEvent = () => this.addPin(!0)),
                            (this.removePinEvent = (t) => window.theme.throttle(this.removePin(t), 50)),
                            (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0));
                    }
                }
            ),
        (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
        (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    const re = window.Shopify.theme.sections.registered,
        ae = window.Shopify.theme.sections.instances,
        le = "data-section-id",
        ce = "data-section-type";
    let de = class {
            getStack() {
                return this.callStack;
            }
            constructor(t = null, e = []) {
                (this.type = t),
                    (this.components = (function (t) {
                        if ((void 0 !== t && "object" != typeof t) || null === t)
                            throw new TypeError("Theme Sections: The components object provided is not a valid");
                        return t;
                    })(e)),
                    (this.callStack = {
                        onLoad: [],
                        onUnload: [],
                        onSelect: [],
                        onDeselect: [],
                        onBlockSelect: [],
                        onBlockDeselect: [],
                        onReorder: [],
                    }),
                    e.forEach((t) => {
                        for (const [e, i] of Object.entries(t)) {
                            const t = this.callStack[e];
                            Array.isArray(t) && "function" == typeof i
                                ? t.push(i)
                                : (console.warn(`Unregisted function: '${e}' in component: '${this.type}'`),
                                  console.warn(i));
                        }
                    });
            }
        },
        he = class {
            callFunctions(t, e = null) {
                this.callStack[t].forEach((t) => {
                    const i = { id: this.id, type: this.type, container: this.container };
                    e ? t.call(i, e) : t.call(i);
                });
            }
            onLoad() {
                this.callFunctions("onLoad");
            }
            onUnload() {
                this.callFunctions("onUnload");
            }
            onSelect(t) {
                this.callFunctions("onSelect", t);
            }
            onDeselect(t) {
                this.callFunctions("onDeselect", t);
            }
            onBlockSelect(t) {
                this.callFunctions("onBlockSelect", t);
            }
            onBlockDeselect(t) {
                this.callFunctions("onBlockDeselect", t);
            }
            onReorder(t) {
                this.callFunctions("onReorder", t);
            }
            constructor(t, e) {
                (this.container = (function (t) {
                    if (!(t instanceof Element))
                        throw new TypeError(
                            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
                        );
                    if (null === t.getAttribute(le))
                        throw new Error(
                            `Theme Sections: The section container provided does not have an id assigned to the ${le} attribute.`
                        );
                    return t;
                })(t)),
                    (this.id = t.getAttribute(le)),
                    (this.type = e.type),
                    (this.callStack = e.getStack());
                try {
                    this.onLoad();
                } catch (t) {
                    console.warn(`Error in section: ${this.id}`), console.warn(this), console.warn(t);
                }
            }
        };
    function ue(t, e) {
        if ("string" != typeof t)
            throw new TypeError(
                "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
            );
        if (void 0 !== re[t])
            throw new Error(
                'Theme Sections: A section of type "' +
                    t +
                    '" has already been registered. You cannot register the same section type twice'
            );
        Array.isArray(e) || (e = [e]);
        const i = new de(t, e);
        return (re[t] = i), re;
    }
    function me(t, e) {
        (t = ge(t)),
            void 0 === e && (e = document.querySelectorAll("[" + ce + "]")),
            (e = fe(e)),
            t.forEach(function (t) {
                const i = re[t];
                void 0 !== i &&
                    (e = e.filter(function (e) {
                        return (
                            !(pe(e).length > 0) &&
                            null !== e.getAttribute(ce) &&
                            (e.getAttribute(ce) !== t || (ae.push(new he(e, i)), !1))
                        );
                    }));
            });
    }
    function pe(t) {
        var e = [];
        if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
        if (t instanceof Element || i instanceof Element)
            fe(t).forEach(function (t) {
                e = e.concat(
                    ae.filter(function (e) {
                        return e.container === t;
                    })
                );
            });
        else if ("string" == typeof t || "string" == typeof i) {
            ge(t).forEach(function (t) {
                e = e.concat(
                    ae.filter(function (e) {
                        return e.type === t;
                    })
                );
            });
        }
        return e;
    }
    function ve(t) {
        for (var e, i = 0; i < ae.length; i++)
            if (ae[i].id === t) {
                e = ae[i];
                break;
            }
        return e;
    }
    function ge(t) {
        return (
            "*" === t
                ? (t = Object.keys(re))
                : "string" == typeof t
                  ? (t = [t])
                  : t.constructor === he
                    ? (t = [t.prototype.type])
                    : Array.isArray(t) &&
                      t[0].constructor === he &&
                      (t = t.map(function (t) {
                          return t.type;
                      })),
            (t = t.map(function (t) {
                return t.toLowerCase();
            }))
        );
    }
    function fe(t) {
        return (
            NodeList.prototype.isPrototypeOf(t) && t.length > 0
                ? (t = Array.prototype.slice.call(t))
                : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
                  ? (t = [])
                  : !Array.isArray(t) && t instanceof Element && (t = [t]),
            t
        );
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (t) {
            var e,
                i,
                s = t.detail.sectionId,
                o =
                    null === (e = t.target) || void 0 === e || null === (i = e.querySelector) || void 0 === i
                        ? void 0
                        : i.call(e, `[${le}="${s}"]`);
            o && me(o.getAttribute(ce), o);
        }),
        document.addEventListener("shopify:section:reorder", function (t) {
            var e,
                i,
                s = t.detail.sectionId,
                o =
                    null === (e = t.target) || void 0 === e || null === (i = e.querySelector) || void 0 === i
                        ? void 0
                        : i.call(e, `[${le}="${s}"]`);
            "object" == typeof pe(o)[0] &&
                pe(o).forEach(function (t) {
                    t.onReorder();
                });
        }),
        document.addEventListener("shopify:section:unload", function (t) {
            var e,
                i,
                s = t.detail.sectionId,
                o =
                    null === (e = t.target) || void 0 === e || null === (i = e.querySelector) || void 0 === i
                        ? void 0
                        : i.call(e, `[${le}="${s}"]`);
            "object" == typeof pe(o)[0] &&
                pe(o).forEach(function (t) {
                    var e = ae
                        .map(function (t) {
                            return t.id;
                        })
                        .indexOf(t.id);
                    ae.splice(e, 1), t.onUnload();
                });
        }),
        document.addEventListener("shopify:section:select", function (t) {
            var e = ve(t.detail.sectionId);
            "object" == typeof e && e.onSelect(t);
        }),
        document.addEventListener("shopify:section:deselect", function (t) {
            var e = ve(t.detail.sectionId);
            "object" == typeof e && e.onDeselect(t);
        }),
        document.addEventListener("shopify:block:select", function (t) {
            var e = ve(t.detail.sectionId);
            "object" == typeof e && e.onBlockSelect(t);
        }),
        document.addEventListener("shopify:block:deselect", function (t) {
            var e = ve(t.detail.sectionId);
            "object" == typeof e && e.onBlockDeselect(t);
        }));
    const be = "data-aos",
        ye = "[data-infinity]",
        we = "[data-pagination]",
        Ee = "data-section-id";
    let Le = {},
        Se = class {
            init() {
                const t = this.container.getAttribute(Ee);
                this.fix(),
                    (this.endlessScroll = new e({
                        container: `section[${Ee}="${t}"] ${ye}`,
                        pagination: `section[${Ee}="${t}"] ${we}`,
                    }));
            }
            fix() {
                e.prototype.loadMore = function () {
                    (this.request = new XMLHttpRequest()),
                        (this.request.onreadystatechange = function () {
                            if (!this.request.responseXML) return;
                            if (4 === !this.request.readyState || 200 === !this.request.status) return;
                            const t = this.request.responseXML.querySelector(this.settings.container),
                                e = this.request.responseXML.querySelector(this.settings.pagination);
                            this.containerElement.insertAdjacentHTML("beforeend", t.innerHTML),
                                null == e
                                    ? this.removePaginationElement()
                                    : ((this.paginationElement.innerHTML = e.innerHTML),
                                      this.settings.callback &&
                                          "function" == typeof this.settings.callback &&
                                          this.settings.callback(this.request.responseXML),
                                      this.initialize());
                        }.bind(this)),
                        this.request.open("GET", this.nextPageUrl, !0),
                        (this.request.responseType = "document"),
                        this.request.send();
                };
            }
            unload() {
                this.endlessScroll && this.endlessScroll.destroy();
            }
            constructor(t) {
                (this.container = t),
                    (this.infinityContainer = this.container.querySelector(ye)),
                    (this.endlessScroll = null),
                    this.infinityContainer && this.init();
            }
        };
    const Ce = {
            onLoad() {
                Le = new Se(this.container);
            },
            onUnload: function () {
                "function" == typeof Le.unload && Le.unload();
            },
        },
        ke = {};
    let Ae = class {
        init() {
            this.checkWindowWidth(), document.addEventListener("theme:resize", this.checkWidthOnResize);
        }
        checkWindowWidth() {
            window.innerWidth < theme.sizes.small &&
                this.container.querySelectorAll(`[${be}]`).forEach((t) => {
                    t.removeAttribute(be);
                });
        }
        onUnload() {
            document.removeEventListener("theme:resize", this.checkWidthOnResize);
        }
        constructor(t) {
            (this.container = t.container), (this.checkWidthOnResize = this.checkWindowWidth()), this.init();
        }
    };
    const Te = {
        onLoad() {
            ke[this.id] = new Ae(this);
        },
        onUnload(t) {
            ke[this.id].onUnload(t);
        },
    };
    ue("blog", [Te, Ce]), ue("featured-blog", Te);
    const qe = "[data-range-slider]",
        xe = "[data-range-left]",
        He = "[data-range-right]",
        Me = "[data-range-line]",
        Fe = "[data-range-holder]",
        De = "data-se-min",
        Ie = "data-se-max",
        Pe = "data-se-min-value",
        Be = "data-se-max-value",
        Oe = "data-se-step",
        _e = "data-range-filter-update",
        Re = "[data-field-price-min]",
        We = "[data-field-price-max]",
        Ne = "is-initialized";
    let $e = class {
        init() {
            let t = this.min;
            this.slider.hasAttribute(Pe) && (t = parseFloat(this.slider.getAttribute(Pe)));
            let e = this.max;
            this.slider.hasAttribute(Be) && (e = parseFloat(this.slider.getAttribute(Be))),
                t < this.min && (t = this.min),
                e > this.max && (e = this.max),
                t > e && (t = e),
                this.slider.getAttribute(Oe) && (this.step = Math.abs(parseFloat(this.slider.getAttribute(Oe)))),
                this.reset(),
                (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                (this.selectedTouch = null),
                (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
                this.setMinValue(t),
                this.setMaxValue(e),
                this.touchLeft.addEventListener("mousedown", this.onStartEvent),
                this.touchRight.addEventListener("mousedown", this.onStartEvent),
                this.touchLeft.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                this.touchRight.addEventListener("touchstart", this.onStartEvent, { passive: !0 }),
                this.slider.classList.add(Ne);
        }
        reset() {
            (this.touchLeft.style.left = "0px"),
                (this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                (this.lineSpan.style.marginLeft = "0px"),
                (this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                (this.startX = 0),
                (this.x = 0);
        }
        setMinValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            (this.touchLeft.style.left =
                Math.ceil(e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) + "px"),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.slider.setAttribute(Pe, t);
        }
        setMaxValue(t) {
            const e = (t - this.min) / (this.max - this.min);
            (this.touchRight.style.left =
                Math.ceil(
                    e * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) +
                        this.normalizeFact
                ) + "px"),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.slider.setAttribute(Be, t);
        }
        onStart(t) {
            t.preventDefault();
            let e = t;
            t.touches && (e = t.touches[0]),
                t.currentTarget === this.touchLeft
                    ? (this.x = this.touchLeft.offsetLeft)
                    : (this.x = this.touchRight.offsetLeft),
                (this.startX = e.pageX - this.x),
                (this.selectedTouch = t.currentTarget),
                document.addEventListener("mousemove", this.onMoveEvent),
                document.addEventListener("mouseup", this.onStopEvent),
                document.addEventListener("touchmove", this.onMoveEvent, { passive: !0 }),
                document.addEventListener("touchend", this.onStopEvent, { passive: !0 });
        }
        onMove(t) {
            let e = t;
            if (
                (t.touches && (e = t.touches[0]),
                (this.x = e.pageX - this.startX),
                this.selectedTouch === this.touchLeft
                    ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
                          ? (this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10)
                          : this.x < 0 && (this.x = 0),
                      (this.selectedTouch.style.left = this.x + "px"))
                    : this.selectedTouch === this.touchRight &&
                      (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
                          ? (this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
                          : this.x > this.maxX && (this.x = this.maxX),
                      (this.selectedTouch.style.left = this.x + "px")),
                (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                this.calculateValue(),
                this.slider.getAttribute("on-change"))
            ) {
                new Function("min, max", this.slider.getAttribute("on-change"))(
                    this.slider.getAttribute(Pe),
                    this.slider.getAttribute(Be)
                );
            }
            this.onChange(this.slider.getAttribute(Pe), this.slider.getAttribute(Be));
        }
        onStop(t) {
            document.removeEventListener("mousemove", this.onMoveEvent),
                document.removeEventListener("mouseup", this.onStopEvent),
                document.removeEventListener("touchmove", this.onMoveEvent),
                document.removeEventListener("touchend", this.onStopEvent),
                (this.selectedTouch = null),
                this.calculateValue(),
                this.onChanged(this.slider.getAttribute(Pe), this.slider.getAttribute(Be));
        }
        onChange(t, e) {
            const i = this.slider.closest(Fe);
            if (i) {
                const s = i.querySelector(Re),
                    o = i.querySelector(We);
                s && o && ((s.value = t), (o.value = e));
            }
        }
        onChanged(t, e) {
            this.slider.hasAttribute(_e) &&
                this.slider.dispatchEvent(new CustomEvent("theme:filter:range-update", { bubbles: !0 }));
        }
        calculateValue() {
            const t = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue;
            let e = this.lineSpan.offsetLeft / this.initialValue,
                i = e + t;
            if (
                ((e = e * (this.max - this.min) + this.min),
                (i = i * (this.max - this.min) + this.min),
                0 !== this.step)
            ) {
                let t = Math.floor(e / this.step);
                (e = this.step * t), (t = Math.floor(i / this.step)), (i = this.step * t);
            }
            this.selectedTouch === this.touchLeft && this.slider.setAttribute(Pe, e),
                this.selectedTouch === this.touchRight && this.slider.setAttribute(Be, i);
        }
        onUnload() {
            this.initFilters && document.removeEventListener("theme:resize:width", this.initFilters);
        }
        constructor(t) {
            (this.container = t.container),
                (this.slider = t.querySelector(qe)),
                (this.initFilters = () => this.init()),
                this.slider &&
                    ((this.onMoveEvent = (t) => this.onMove(t)),
                    (this.onStopEvent = (t) => this.onStop(t)),
                    (this.onStartEvent = (t) => this.onStart(t)),
                    (this.startX = 0),
                    (this.x = 0),
                    (this.touchLeft = this.slider.querySelector(xe)),
                    (this.touchRight = this.slider.querySelector(He)),
                    (this.lineSpan = this.slider.querySelector(Me)),
                    (this.min = parseFloat(this.slider.getAttribute(De))),
                    (this.max = parseFloat(this.slider.getAttribute(Ie))),
                    (this.step = 0),
                    (this.normalizeFact = 26),
                    document.addEventListener("theme:resize:width", this.initFilters),
                    document.addEventListener("theme:filter:init", this.initFilters),
                    this.init());
        }
    };
    const ze = {};
    let Ue = class {
        init() {
            this.updateFiltersStickyHeaderHeight(),
                this.collectionProducts && (this.collection = this.collectionProducts.getAttribute("data-collection")),
                this.reinitDynamicElements({ initPosition: !0 }),
                document.addEventListener("theme:resize", this.resizeFiltersEvent),
                window.addEventListener("load", this.updateFiltersStickyHeaderHeightEvent),
                document.addEventListener("shopify:section:load", this.onSectionLoadEvent);
        }
        refreshDynamicReferences() {
            (this.filters = this.container.querySelector("[data-filters]")),
                (this.filtersForm = this.container.querySelector("[data-filters-form]")),
                (this.accordionElements = this.container.querySelector("accordion-elements")),
                (this.collectionSortInputs = this.container.querySelectorAll("[data-collection-sort]")),
                (this.filterToggleBtn = this.container.querySelector("[data-toggle-filters]")),
                (this.filtersSticky = this.container.querySelector("[data-filters-sticky]"));
        }
        reinitDynamicElements({ initPosition: t = !1 } = {}) {
            this.refreshDynamicReferences(),
                this.filtersEnable &&
                    this.filters &&
                    (this.initFacetedFilters(), this.checkFiltersPosition(t), this.initFilterToggleButtons()),
                this.initSort(),
                this.initShowMoreOptions(),
                this.initMobileFiltersToggle(),
                this.bindSwatchFilters();
        }
        initShowMoreOptions() {
            var t;
            (this.showMoreOptions = this.container.querySelectorAll("[data-show-more]")),
                null === (t = this.showMoreOptions) ||
                    void 0 === t ||
                    t.forEach((t) => {
                        t.removeEventListener("click", this.showMoreEvent),
                            t.addEventListener("click", this.showMoreEvent);
                    });
        }
        updateFiltersStickyHeaderHeight() {
            if (!this.filtersSticky) return;
            const t = document.querySelector("[data-header-height]");
            (null == t ? void 0 : t.classList.contains("header--sticky"))
                ? this.filtersSticky.style.removeProperty("--header-height")
                : this.filtersSticky.style.setProperty("--header-height", "0px");
        }
        initSort() {
            this.collectionSortInputs.length &&
                this.collectionSortInputs.forEach((t) => {
                    t.removeEventListener("change", this.sortChangeEvent),
                        t.addEventListener("change", this.sortChangeEvent);
                });
        }
        onSortChange(t) {
            var e;
            const i = new window.URL(window.location.href),
                s = t.currentTarget.value,
                o = i.searchParams;
            o.set("sort_by", s),
                (i.search = o.toString()),
                this.collectionProducts.setAttribute("data-sort", s),
                this.requestFilteredProducts(i.toString()),
                null === (e = this.closeMobileFilters) || void 0 === e || e.call(this);
        }
        initMobileFiltersToggle() {
            this.filterToggleBtn &&
                this.filtersSticky &&
                (this.filterToggleBtn.removeEventListener("click", this.toggleMobileFiltersEvent),
                this.filterToggleBtn.addEventListener("click", this.toggleMobileFiltersEvent));
        }
        toggleMobileFilters() {
            this.filtersSticky.classList.contains("is-open")
                ? this.closeMobileFilters()
                : (this.filtersSticky.classList.add("is-open"),
                  document.addEventListener("click", this.mobileFiltersOutsideClick));
        }
        closeMobileFilters() {
            var t;
            (null === (t = this.filtersSticky) || void 0 === t ? void 0 : t.classList.contains("is-open")) &&
                (this.filtersSticky.classList.remove("is-open"),
                document.removeEventListener("click", this.mobileFiltersOutsideClick));
        }
        closeMobileFiltersOnOutsideClick(t) {
            var e, i;
            !(null === (e = this.filtersSticky) || void 0 === e ? void 0 : e.contains(t.target)) &&
                (null === (i = this.filtersSticky) || void 0 === i ? void 0 : i.classList.contains("is-open")) &&
                this.closeMobileFilters();
        }
        initFilterToggleButtons() {
            var t;
            this.filters &&
                (null === (t = this.filters.querySelectorAll("[data-accordion-trigger]")) ||
                    void 0 === t ||
                    t.forEach((t) => {
                        t.removeEventListener("click", this.filterAccordionToggleEvent),
                            t.addEventListener("click", this.filterAccordionToggleEvent);
                    }));
        }
        onFilterAccordionToggle(t) {
            const e = t.currentTarget,
                i = e.parentNode.querySelector("[data-filter-container]").getBoundingClientRect().top;
            document.documentElement.style.setProperty("--filters-top", `${i}px`);
            e.parentNode.querySelector("[data-range-slider]") &&
                !this.isRangeSliderInitialized &&
                (this.filtersForm.dispatchEvent(new CustomEvent("theme:filter:init", { bubbles: !0 })),
                (this.isRangeSliderInitialized = !0)),
                document.addEventListener("click", this.documentClick);
        }
        showMore(t) {
            t.preventDefault();
            const e = t.target.matches("[data-show-more]") ? t.target : t.target.closest("[data-show-more]");
            e.parentElement.classList.add("hidden"),
                e.parentElement.previousElementSibling.querySelectorAll("[data-link-hidden]").forEach((t, e) => {
                    t.classList.remove("hidden");
                    const i = t.querySelector("input");
                    0 === e &&
                        document.body.classList.contains("is-focused") &&
                        i &&
                        (this.collectionSidebarSlideOut || window.theme.isMobile()
                            ? (this.a11y.removeTrapFocus(),
                              this.a11y.trapFocus(this.collectionSidebar, { elementToFocus: i }))
                            : i.focus());
                });
        }
        initFacetedFilters() {
            this.filters.hasAttribute("data-filters-available") &&
                (new $e(this.filtersForm),
                (this.filtersInputs = this.filtersForm.querySelectorAll("input, select, label, textarea")),
                this.filtersInputs.length &&
                    this.filtersInputs.forEach((t) => {
                        t.addEventListener(
                            "input",
                            window.theme.debounce(() => {
                                this.filtersForm && "function" == typeof this.filtersForm.submit && this.submitForm();
                            }, 500)
                        );
                    }),
                this.filtersForm.addEventListener("theme:filter:range-update", () => this.updateRange()),
                this.initResets());
        }
        submitForm() {
            const t = new FormData(this.filtersForm),
                e = new URLSearchParams(t);
            this.requestFilteredProducts(`${this.collection}${e.toString()}`);
        }
        initResets() {
            const t = this.container.querySelectorAll("[data-filter-reset-button]");
            (this.resetAlt = this.collectionProducts.querySelector("[data-filters-reset-button]")),
                t.length &&
                    t.forEach((t) => {
                        t.addEventListener("click", (t) => this.bindResetButton(t));
                    }),
                this.resetAlt && this.resetAlt.addEventListener("click", (t) => this.bindResetButton(t));
        }
        updateRange() {
            if (this.filtersForm && "function" == typeof this.filtersForm.submit) {
                const t = this.filtersForm.querySelector("[data-se-min-value]"),
                    e = this.filtersForm.querySelector("[data-se-max-value]"),
                    i = this.filtersForm.querySelector("[data-field-price-min]"),
                    s = this.filtersForm.querySelector("[data-field-price-max]");
                if (t && e && i && s && t.hasAttribute("data-se-min-value") && e.hasAttribute("data-se-max-value")) {
                    const o = parseInt(i.placeholder),
                        n = parseInt(s.placeholder),
                        r = parseInt(t.getAttribute("data-se-min-value")),
                        a = parseInt(e.getAttribute("data-se-max-value"));
                    (o === r && n === a) || ((i.value = r), (s.value = a), this.submitForm());
                }
            }
        }
        closeOnOutsideClick(t) {
            const e = this.filters.contains(t.target),
                i = this.filters.querySelector("details[open]");
            if (!e && i && this.isTopPosition()) {
                this.filters
                    .querySelector("details[open]")
                    .querySelector("[data-accordion-trigger]")
                    .dispatchEvent(new Event("click")),
                    document.removeEventListener("click", this.documentClick);
            }
        }
        requestFilteredProducts(t) {
            const e = parseInt(Math.ceil(this.collectionWrapper.offsetTop) - theme.dimensions.headerScrolled);
            this.collectionWrapper.classList.add("is-loading"),
                window.scrollTo({ top: e, left: 0, behavior: "smooth" }),
                history.replaceState && window.history.pushState({ path: t }, "", t),
                fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                        const e = document.createElement("div");
                        e.innerHTML = t;
                        const i = e.querySelector("[data-collection-products]"),
                            s = e.querySelector("[data-pagination]"),
                            o = e.querySelector("[data-filters]");
                        if (i && this.collectionProducts) {
                            if (
                                ((this.collectionProducts.innerHTML = i.innerHTML),
                                this.pagination && (this.pagination.innerHTML = null !== s ? s.innerHTML : ""),
                                this.pagination ||
                                    null === s ||
                                    (this.collectionGridWrapper.appendChild(s),
                                    (this.pagination = this.collectionGridWrapper.querySelector("[data-pagination]"))),
                                o && this.filters)
                            ) {
                                const t = o.innerHTML;
                                this.filters.innerHTML = t;
                            }
                            this.reinitDynamicElements(), Ce.onUnload(), new Se(this.container);
                        }
                    })
                    .catch((t) => {
                        this.collectionWrapper.classList.remove("is-loading");
                    })
                    .finally(() => {
                        setTimeout(() => {
                            this.collectionWrapper.classList.remove("is-loading");
                        }, 450);
                    });
        }
        checkFiltersPosition(t = !1) {
            if (!this.filters) return;
            const e = this.isTopPosition() ? "top" : "left",
                i = this.filtersPositionState !== e;
            if (t || i) {
                var s, o, n;
                if (this.isTopPosition())
                    null === (s = this.accordionElements) || void 0 === s || s.setAttribute("single", !0),
                        null === (o = this.filters.querySelectorAll("details[open]")) ||
                            void 0 === o ||
                            o.forEach((t) => {
                                t.hasAttribute("open") &&
                                    (t.removeAttribute("open"),
                                    (t.querySelector("[data-filter-container]").style.height = 0));
                            });
                else null === (n = this.accordionElements) || void 0 === n || n.removeAttribute("single");
                this.filtersPositionState = e;
            }
        }
        isTopPosition() {
            var t;
            return (
                window.innerWidth < theme.sizes.widescreen ||
                (null === (t = this.filters) || void 0 === t
                    ? void 0
                    : t.classList.contains("collection__filters--top"))
            );
        }
        bindResetButton(t) {
            t.preventDefault(), this.requestFilteredProducts(t.currentTarget.href);
        }
        onUnload() {
            document.removeEventListener("theme:resize", this.resizeFiltersEvent),
                window.removeEventListener("load", this.updateFiltersStickyHeaderHeightEvent),
                document.removeEventListener("shopify:section:load", this.onSectionLoadEvent);
        }
        bindSwatchFilters() {
            this.swatches = [];
            this.container.querySelectorAll("[data-swatch]").forEach((t) => {
                "function" == typeof Swatch && this.swatches.push(new Swatch(t));
            });
        }
        constructor(t) {
            (this.container = t.container),
                (this.collectionGridWrapper = this.container.querySelector("[data-collection-grid-wrapper]")),
                (this.collectionProducts = this.container.querySelector("[data-collection-products]")),
                (this.collectionWrapper = this.container.querySelector("[data-collection-wrapper]")),
                (this.pagination = this.container.querySelector("[data-pagination]")),
                (this.accordionElements = this.container.querySelector("accordion-elements")),
                (this.filters = this.container.querySelector("[data-filters]")),
                (this.filtersEnable = "true" === this.container.getAttribute("data-filters-enable")),
                (this.filtersForm = this.container.querySelector("[data-filters-form]")),
                (this.filtersResets = this.container.querySelector("[data-filters-reset]")),
                (this.showMoreOptions = this.container.querySelectorAll("[data-show-more]")),
                (this.filterToggleBtn = this.container.querySelector("[data-toggle-filters]")),
                (this.filtersSticky = this.container.querySelector("[data-filters-sticky]")),
                (this.collectionSortInputs = this.container.querySelectorAll("[data-collection-sort]")),
                (this.filtersInputs = []),
                (this.sort = null),
                (this.collection = null),
                (this.reset = null),
                (this.filtersPositionState = this.isTopPosition() ? "top" : "left"),
                (this.isRangeSliderInitialized = !1),
                (this.showMoreEvent = (t) => this.showMore(t)),
                (this.sortChangeEvent = (t) => this.onSortChange(t)),
                (this.filterAccordionToggleEvent = (t) => this.onFilterAccordionToggle(t)),
                (this.toggleMobileFiltersEvent = () => this.toggleMobileFilters()),
                (this.resizeFiltersEvent = () => this.checkFiltersPosition()),
                (this.updateFiltersStickyHeaderHeightEvent = () => this.updateFiltersStickyHeaderHeight()),
                (this.onSectionLoadEvent = () => this.updateFiltersStickyHeaderHeight()),
                (this.documentClick = (t) => this.closeOnOutsideClick(t)),
                (this.mobileFiltersOutsideClick = (t) => this.closeMobileFiltersOnOutsideClick(t)),
                this.init();
        }
    };
    const Ve = {
        onLoad() {
            ze[this.id] = new Ue(this);
        },
        onUnload(t) {
            ze[this.id].onUnload(t);
        },
    };
    ue("collection", [Ve, Ce]), ue("search-template", [Ve, Ce]);
    ue("footer", [
        {
            onLoad() {
                var t = document.querySelector("[data-powered-link] a");
                t && t.setAttribute("rel", "noopener");
            },
        },
    ]);
    const je = "[data-faq-trigger]",
        Ke = "[data-accordion-trigger]",
        Qe = "data-index",
        Xe = "is-active";
    let Ge = class extends n {
        connectedCallback() {
            (this.triggers = this.querySelectorAll(je)),
                this.triggers.forEach((t) => {
                    t.addEventListener("click", (e) => {
                        if (t.classList.contains(Xe)) return;
                        const i = this.querySelector(`${je}.${Xe}`),
                            s = this.querySelector(`${Ke}[${Qe}="${t.dataset.index}"]`);
                        null == i || i.classList.remove(Xe),
                            null == i || i.setAttribute("aria-expanded", "false"),
                            null == s || s.click(),
                            t.classList.add(Xe),
                            t.setAttribute("aria-expanded", "true");
                    });
                });
        }
        constructor() {
            super();
        }
    };
    customElements.get("faq-list") || customElements.define("faq-list", Ge), ue("collection-grid", [Ce]);
    const Ye = {},
        Je = "[data-logo-list-slider]",
        Ze = "[data-logo-list-slide]",
        ti = "data-logo-list-slide",
        ei = "data-slide-index",
        ii = "flickity-enabled";
    let si = class {
        init() {
            this.sliderInit(), document.addEventListener("theme:resize", this.sliderInitEvent);
        }
        sliderInit() {
            const t = this.slideshow.querySelectorAll(Ze).length,
                e = document.documentElement.clientWidth || document.body.clientWidth,
                s = 220 * t,
                o = this.slideshow.classList.contains(ii);
            e < s
                ? o ||
                  (this.flkty = new i(this.slideshow, {
                      autoPlay: 4e3,
                      prevNextButtons: !1,
                      pageDots: !1,
                      wrapAround: !0,
                  }))
                : o && this.flkty.destroy();
        }
        onUnload() {
            this.slideshow.classList.contains(ii) && this.flkty.destroy(),
                document.removeEventListener("theme:resize", this.sliderInitEvent);
        }
        onBlockSelect(t) {
            const e = this.slideshow.querySelector(`[${ti}="${t.detail.blockId}"]`),
                i = parseInt(e.getAttribute(ei));
            this.slideshow.classList.contains(ii) && (this.flkty.select(i), this.flkty.pausePlayer());
        }
        onBlockDeselect() {
            this.slideshow.classList.contains(ii) && this.flkty.unpausePlayer();
        }
        constructor(t) {
            (this.container = t.container),
                (this.slideshow = this.container.querySelector(Je)),
                (this.sliderInitEvent = () => this.sliderInit()),
                this.init();
        }
    };
    ue("logo-list", {
        onLoad() {
            Ye[this.id] = new si(this);
        },
        onUnload(t) {
            Ye[this.id].onUnload(t);
        },
        onBlockSelect(t) {
            Ye[this.id].onBlockSelect(t);
        },
        onBlockDeselect() {
            Ye[this.id].onBlockDeselect();
        },
    });
    const oi = {};
    function ni(t = {}) {
        if ((t.type || (t.type = "json"), t.url))
            return oi[t.url]
                ? oi[t.url]
                : (function (t, e) {
                      const i = new Promise((i, s) => {
                          "text" === e
                              ? fetch(t)
                                    .then((t) => t.text())
                                    .then((t) => {
                                        i(t);
                                    })
                                    .catch((t) => {
                                        s(t);
                                    })
                              : (function (t, e, i) {
                                    let s = document.getElementsByTagName("head")[0],
                                        o = !1,
                                        n = document.createElement("script");
                                    (n.src = t),
                                        (n.onload = n.onreadystatechange =
                                            function () {
                                                o ||
                                                (this.readyState &&
                                                    "loaded" != this.readyState &&
                                                    "complete" != this.readyState)
                                                    ? i()
                                                    : ((o = !0), e());
                                            }),
                                        s.appendChild(n);
                                })(
                                    t,
                                    function () {
                                        i();
                                    },
                                    function () {
                                        s();
                                    }
                                );
                      });
                      return (oi[t] = i), i;
                  })(t.url, t.type);
        if (t.json)
            return oi[t.json]
                ? Promise.resolve(oi[t.json])
                : window
                      .fetch(t.json)
                      .then((t) => t.json())
                      .then((e) => ((oi[t.json] = e), e));
        if (t.name) {
            const e = "".concat(t.name, t.version);
            return oi[e]
                ? oi[e]
                : (function (t) {
                      const e = "".concat(t.name, t.version),
                          i = new Promise((e, i) => {
                              try {
                                  window.Shopify.loadFeatures([
                                      {
                                          name: t.name,
                                          version: t.version,
                                          onLoad: (t) => {
                                              !(function (t, e, i) {
                                                  i ? e(i) : t();
                                              })(e, i, t);
                                          },
                                      },
                                  ]);
                              } catch (t) {
                                  i(t);
                              }
                          });
                      return (oi[e] = i), i;
                  })(t);
        }
        return Promise.reject();
    }
    const ri = ".pswp",
        ai = ".pswp__custom-close",
        li = "iframe, video",
        ci = ".pswp__thumbs",
        di = "data-pswp-option-classes",
        hi = "is-current",
        ui = "pswp--custom-loader",
        mi = "pswp--custom-opening",
        pi = "pswp__loader",
        vi = `<div class="${pi}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`;
    let gi = class {
        init() {
            this.pswpElement.classList.add(mi),
                this.initLoader(),
                ni({ url: window.theme.assets.photoswipe })
                    .then(() => this.loadPopup())
                    .catch((t) => console.error(t));
        }
        initLoader() {
            if (this.pswpElement.classList.contains(ui) && "" !== this.options && this.options.mainClass) {
                this.pswpElement.setAttribute(di, this.options.mainClass);
                let t = document.createElement("div");
                (t.innerHTML = vi), (t = t.firstChild), this.pswpElement.appendChild(t);
            } else this.pswpElement.setAttribute(di, "");
        }
        loadPopup() {
            const t = window.themePhotoswipe.PhotoSwipe.default,
                e = window.themePhotoswipe.PhotoSwipeUI.default;
            this.pswpElement.classList.contains(ui) && this.pswpElement.classList.remove(ui),
                this.pswpElement.classList.remove(mi),
                (this.popup = new t(this.pswpElement, e, this.items, this.options)),
                this.popup.init(),
                this.a11y.trapFocus(this.pswpElement),
                this.thumbsActions(),
                this.closeBtn && this.closeBtn.addEventListener("click", this.closeButtonClick),
                this.popup.listen("close", () => this.onClose());
        }
        closeButtonClickEvent() {
            this.popup.close(), this.a11y.removeTrapFocus(), null !== theme.a11yTrigger && theme.a11yTrigger.focus();
        }
        thumbsActions() {
            this.popupThumbsContainer &&
                this.popupThumbsContainer.firstChild &&
                (this.popupThumbsContainer.addEventListener("wheel", (t) => this.stopDisabledScroll(t)),
                this.popupThumbsContainer.addEventListener("mousewheel", (t) => this.stopDisabledScroll(t)),
                this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) => this.stopDisabledScroll(t)),
                (this.popupThumbs = this.pswpElement.querySelectorAll(`${ci} > *`)),
                this.popupThumbs.forEach((t, e) => {
                    t.addEventListener("click", (i) => {
                        i.preventDefault(),
                            t.parentElement.querySelector(`.${hi}`).classList.remove(hi),
                            t.classList.add(hi),
                            this.popup.goTo(e);
                    });
                }),
                this.popup.listen("imageLoadComplete", () => this.setCurrentThumb()),
                this.popup.listen("beforeChange", () => this.setCurrentThumb()));
        }
        stopDisabledScroll(t) {
            t.stopPropagation();
        }
        onClose() {
            const t = this.pswpElement.querySelector(li);
            if ((t && t.parentNode.removeChild(t), this.popupThumbsContainer && this.popupThumbsContainer.firstChild))
                for (; this.popupThumbsContainer.firstChild; )
                    this.popupThumbsContainer.removeChild(this.popupThumbsContainer.firstChild);
            this.pswpElement.setAttribute(di, "");
            const e = this.pswpElement.querySelector(`.${pi}`);
            e && this.pswpElement.removeChild(e),
                this.a11y.removeTrapFocus(),
                null !== theme.a11yTrigger && theme.a11yTrigger.focus(),
                this.closeBtn.removeEventListener("click", this.closeButtonClick);
        }
        setCurrentThumb() {
            const t = this.pswpElement.querySelector(`${ci} > .${hi}`);
            if ((t && t.classList.remove(hi), !this.popupThumbs)) return;
            const e = this.popupThumbs[this.popup.getCurrentIndex()];
            e.classList.add(hi), this.scrollThumbs(e);
        }
        scrollThumbs(t) {
            const e = this.popupThumbsContainer.scrollLeft + this.popupThumbsContainer.offsetWidth,
                i = t.offsetLeft;
            if (e <= i + t.offsetWidth || e > i) {
                const e = parseInt(window.getComputedStyle(t).marginLeft);
                this.popupThumbsContainer.scrollTo({ top: 0, left: i - e, behavior: "smooth" });
            }
        }
        constructor(t, e = "") {
            (this.a11y = g),
                (this.items = t),
                (this.pswpElement = document.querySelectorAll(ri)[0]),
                (this.popup = null),
                (this.popupThumbs = null),
                (this.popupThumbsContainer = this.pswpElement.querySelector(ci)),
                (this.closeBtn = this.pswpElement.querySelector(ai)),
                (this.closeButtonClick = () => this.closeButtonClickEvent());
            (this.options = "" !== e ? e : { history: !1, focus: !1, mainClass: "" }), this.init();
        }
    };
    const fi = "[data-video-play]",
        bi = "data-video-play";
    let yi = class {
        constructor(t, e = fi, i = bi) {
            (this.container = t),
                (this.videoPlay = this.container.querySelectorAll(e)),
                this.videoPlay.length &&
                    this.videoPlay.forEach((t) => {
                        t.addEventListener("click", (t) => {
                            const e = t.currentTarget;
                            if (e.hasAttribute(i) && "" !== e.getAttribute(i).trim()) {
                                t.preventDefault(), (theme.a11yTrigger = e);
                                const s = [{ html: e.getAttribute(i) }];
                                new gi(s);
                            }
                        });
                    });
        }
    };
    const wi = {
            onLoad() {
                new yi(this.container);
            },
        },
        Ei = {},
        Li = "[data-mosaic-blocks]",
        Si = "[data-prev-arrow]",
        Ci = "[data-next-arrow]",
        ki = "data-slide",
        Ai = "data-slide-index",
        Ti = "flickity-enabled";
    let qi = class {
        init() {
            this.initMobileSlider(), document.addEventListener("theme:resize", this.sliderInitEvent);
        }
        initMobileSlider() {
            const t = theme.isMobile(),
                e = { wrapAround: !0, prevNextButtons: !1, pageDots: !1 },
                s = () => this.flkty.previous(!0),
                o = () => this.flkty.next(!0);
            t && !this.isInit()
                ? ((this.flkty = new i(this.slideshow, e)),
                  this.slideshowPrev &&
                      this.slideshowNext &&
                      (this.slideshowPrev.addEventListener("click", s),
                      this.slideshowNext.addEventListener("click", o)))
                : !t &&
                  this.isInit() &&
                  (this.flkty.destroy(),
                  this.slideshowPrev &&
                      this.slideshowNext &&
                      (this.slideshowPrev.removeEventListener("click", s),
                      this.slideshowNext.removeEventListener("click", o)));
        }
        isInit() {
            var t;
            return null === (t = this.slideshow) || void 0 === t ? void 0 : t.classList.contains(Ti);
        }
        onUnload() {
            this.isInit() && this.flkty.destroy(), document.removeEventListener("theme:resize", this.sliderInitEvent);
        }
        onBlockSelect(t) {
            const e = this.container.querySelector(`[${ki}="${t.detail.blockId}"]`);
            this.isInit() && null !== e && this.flkty.select(parseInt(e.getAttribute(Ai)));
        }
        constructor(t) {
            (this.container = t.container),
                (this.slideshow = this.container.querySelector(Li)),
                (this.slideshowPrev = this.container.querySelector(Si)),
                (this.slideshowNext = this.container.querySelector(Ci)),
                (this.flkty = null),
                (this.sliderInitEvent = () => this.initMobileSlider()),
                this.init();
        }
    };
    ue("mosaic", [
        {
            onLoad() {
                Ei[this.id] = new qi(this);
            },
            onUnload(t) {
                Ei[this.id].onUnload(t);
            },
            onBlockSelect(t) {
                Ei[this.id].onBlockSelect(t);
            },
        },
        wi,
    ]);
    const xi = ".input-group--error",
        Hi = "input.password, input.email";
    let Mi = class {
        init() {
            this.inputGroups.forEach((t) => {
                t.querySelector(Hi).focus();
            });
        }
        constructor(t) {
            (this.container = t.container), (this.inputGroups = this.container.querySelectorAll(xi)), this.init();
        }
    };
    ue("password", {
        onLoad() {
            new Mi(this);
        },
    });
    let Fi = class {
        write() {
            ((-1 !== document.cookie.indexOf("; ") &&
                !document.cookie.split("; ").find((t) => t.startsWith(this.name))) ||
                -1 === document.cookie.indexOf("; ")) &&
                (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
        }
        read() {
            if (
                -1 !== document.cookie.indexOf("; ") &&
                document.cookie.split("; ").find((t) => t.startsWith(this.name))
            ) {
                return document.cookie
                    .split("; ")
                    .find((t) => t.startsWith(this.name))
                    .split("=")[1];
            }
            return !1;
        }
        destroy() {
            document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
                (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
        }
        constructor(t, e, i) {
            (this.configuration = { expires: i, path: "/", domain: window.location.hostname }),
                (this.name = t),
                (this.value = e);
        }
    };
    const Di = "[data-popup]",
        Ii = "[data-popup-close]",
        Pi = "popup--visible",
        Bi = "data-delay",
        Oi = "data-reappear_time",
        _i = "data-testmode",
        Ri = "true";
    let Wi = {},
        Ni = class {
            expireDate() {
                const t = new Date(),
                    e = new Date();
                let i = parseInt(this.popup.getAttribute(Oi));
                return (
                    0 !== i ? e.setTime(t.getTime() + 864e5 * i) : e.setTime(t.getTime() + 31536e8),
                    (i = e.toGMTString()),
                    i
                );
            }
            init() {
                const t = !1 !== this.cookie.read(),
                    e = "/challenge" === window.location.pathname;
                -1 !== window.location.search.indexOf("?customer_posted=true") && (this.delay = 0),
                    ((!t && !e) || this.testmode) &&
                        (this.timeout = setTimeout(() => {
                            this.popup.classList.add(Pi),
                                this.popup.setAttribute("aria-hidden", "false"),
                                this.initClosers(),
                                this.close.focus();
                        }, this.delay));
            }
            initClosers() {
                this.close.addEventListener("click", this.closeModal.bind(this));
            }
            closeModal(t) {
                t.preventDefault(),
                    this.popup.classList.remove(Pi),
                    this.popup.setAttribute("aria-hidden", "true"),
                    clearTimeout(this.timeout),
                    this.testmode || this.cookie.write();
            }
            constructor(t) {
                (this.popup = t),
                    (this.close = this.popup.querySelector(Ii)),
                    (this.timeout = 0),
                    (this.testmode = this.popup.getAttribute(_i) === Ri),
                    (this.delay = 1e3 * parseInt(this.popup.getAttribute(Bi))),
                    (this.cookie = new Fi("newsletter", "user_has_closed", this.expireDate())),
                    this.init();
            }
        };
    ue("popup", [
        {
            onLoad() {
                const t = this.container.querySelector(Di);
                null !== t && (Wi[this.id] = new Ni(t));
            },
        },
    ]),
        ue("recently-viewed-products", {
            onLoad() {
                const t = this.container,
                    e = t.querySelector("#RecentlyViewed"),
                    i = parseInt(t.getAttribute("data-limit"), 10) || 4;
                e && Shopify.Products.showRecentlyViewed({ howManyToShow: i, onComplete: () => {} });
            },
        });
    const $i = {},
        zi = '[data-section-type="related-products"]',
        Ui = "[data-product-block]",
        Vi = "data-section-id",
        ji = "data-product-id",
        Ki = "data-limit";
    let Qi = class {
        init() {
            const t = this.container,
                e = t.getAttribute(Vi),
                i = t.getAttribute(ji),
                s = t.getAttribute(Ki),
                o = `${theme.routes.product_recommendations_url}?section_id=${e}&limit=${s}&product_id=${i}`;
            fetch(o)
                .then((t) => t.text())
                .then((e) => {
                    const i = document.createElement("div");
                    i.innerHTML = e;
                    const s = i.querySelector(zi);
                    s.querySelector(Ui) && (t.innerHTML = s.innerHTML);
                });
        }
        constructor(t) {
            (this.container = t.container), this.init();
        }
    };
    ue("related-products", {
        onLoad() {
            $i[this.id] = new Qi(this);
        },
    });
    let Xi = class extends HTMLElement {
        connectedCallback() {
            var t, e, i, o, n, r;
            (this.parentContainer = this.closest(".shopify-section")),
                (this.slideshowPrev =
                    null === (t = this.parentContainer) || void 0 === t
                        ? void 0
                        : t.querySelector("[data-prev-arrow]")),
                (this.slideshowNext =
                    null === (e = this.parentContainer) || void 0 === e
                        ? void 0
                        : e.querySelector("[data-next-arrow]")),
                (this.scrollBtn =
                    null === (i = this.parentContainer) || void 0 === i
                        ? void 0
                        : i.querySelector("[data-button-scroll]"));
            const a = {
                ...JSON.parse(this.getAttribute("data-options").replace(/'/g, '"')),
                cellSelector: "[data-slide]",
                on: {
                    ready: () => {
                        requestAnimationFrame(() => this.classList.remove("hero--is-loading"));
                    },
                    change: (t) => this.replaySlideAnimations(t),
                },
            };
            (this.flkty = new s(this, a)),
                null === (o = this.slideshowPrev) || void 0 === o || o.addEventListener("click", this.handlePrevClick),
                null === (n = this.slideshowNext) || void 0 === n || n.addEventListener("click", this.handleNextClick),
                null === (r = this.scrollBtn) || void 0 === r || r.addEventListener("click", this.handleScrollClick),
                document.addEventListener("theme:scroll", this.handleCheckVisibility),
                document.addEventListener("theme:resize:width", this.handleResizeWidth),
                this.addEventListener("theme:slideshow:selectSlide", this.handleSelectSlide),
                this.addEventListener("theme:slideshow:deselect", this.handleDeselectSlide),
                this.addEventListener("shopify:section:unload", this.handleUnload);
        }
        onScrollClick(t) {
            t.preventDefault();
            const e =
                    parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height"), 10) || 60,
                i = this.parentContainer.offsetTop + this.parentContainer.offsetHeight - e;
            window.scrollTo({ top: i, behavior: "smooth" });
        }
        onSelectSlide(t) {
            var e;
            this.flkty &&
                "number" == typeof (null === (e = t.detail) || void 0 === e ? void 0 : e.index) &&
                (this.flkty.select(t.detail.index), this.flkty.stopPlayer());
        }
        onDeselectSlide() {
            this.isAutoplay() && this.flkty.playPlayer();
        }
        isAutoplay() {
            return Boolean(this.flkty) && !1 !== this.flkty.options.autoPlay;
        }
        replaySlideAnimations(t) {
            var e, i, s;
            const o =
                null === (e = this.flkty) ||
                void 0 === e ||
                null === (i = e.cells) ||
                void 0 === i ||
                null === (s = i[t]) ||
                void 0 === s
                    ? void 0
                    : s.element;
            if (!o) return;
            const n = o.querySelectorAll("[data-aos]");
            n.length &&
                (n.forEach((t) => {
                    t.classList.add("aos-no-transition"), t.classList.remove("aos-animate");
                }),
                o.offsetHeight,
                n.forEach((t) => {
                    t.classList.remove("aos-no-transition");
                }),
                requestAnimationFrame(() => {
                    n.forEach((t) => t.classList.add("aos-animate"));
                }));
        }
        checkSliderVisibility() {
            if (!this.flkty) return;
            const t = this.classList.contains("flickity-enabled");
            (window.visibilityHelper.isElementPartiallyVisible(this) ||
                window.visibilityHelper.isElementTotallyVisible(this)) &&
            t &&
            this.isAutoplay()
                ? this.flkty.playPlayer()
                : this.flkty.stopPlayer();
        }
        disconnectedCallback() {
            var t, e, i;
            this.flkty &&
                (this.flkty.destroy(),
                (this.flkty = null),
                document.removeEventListener("theme:scroll", this.handleCheckVisibility),
                document.removeEventListener("theme:resize:width", this.handleResizeWidth),
                null === (t = this.slideshowPrev) ||
                    void 0 === t ||
                    t.removeEventListener("click", this.handlePrevClick),
                null === (e = this.slideshowNext) ||
                    void 0 === e ||
                    e.removeEventListener("click", this.handleNextClick),
                null === (i = this.scrollBtn) || void 0 === i || i.removeEventListener("click", this.handleScrollClick),
                this.removeEventListener("theme:slideshow:selectSlide", this.handleSelectSlide),
                this.removeEventListener("theme:slideshow:deselect", this.handleDeselectSlide),
                this.removeEventListener("shopify:section:unload", this.handleUnload));
        }
        constructor() {
            super(),
                (this.flkty = null),
                (this.handleCheckVisibility = () => this.checkSliderVisibility()),
                (this.handlePrevClick = () => {
                    var t;
                    return null === (t = this.flkty) || void 0 === t ? void 0 : t.previous(!0);
                }),
                (this.handleNextClick = () => {
                    var t;
                    return null === (t = this.flkty) || void 0 === t ? void 0 : t.next(!0);
                }),
                (this.handleScrollClick = (t) => this.onScrollClick(t)),
                (this.handleSelectSlide = (t) => this.onSelectSlide(t)),
                (this.handleDeselectSlide = () => this.onDeselectSlide()),
                (this.handleUnload = () => this.disconnectedCallback()),
                (this.handleResizeWidth = () => {
                    var t;
                    return null === (t = this.flkty) || void 0 === t ? void 0 : t.resize();
                });
        }
    };
    customElements.define("slideshow-element", Xi),
        ue("featured-video", [wi]),
        document.addEventListener("DOMContentLoaded", function () {
            me("*");
            document.querySelectorAll("[data-anchor-link]").forEach((t) => {
                t.addEventListener("click", (e) => {
                    e.preventDefault();
                    const i =
                        document.getElementById(t.getAttribute("href").split("#")[1]).getBoundingClientRect().top +
                        window.scrollY -
                        theme.dimensions.headerScrolled;
                    window.scrollTo({ top: i, left: 0, behavior: "smooth" });
                });
            });
            document
                .querySelectorAll(
                    '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
                )
                .forEach((t) => {
                    W(t, "rte__video-wrapper");
                }),
                window.self !== window.top && document.querySelector("html").classList.add("iframe");
        }),
        window.navigator.cookieEnabled &&
            (document.documentElement.className = document.documentElement.className.replace(
                "supports-no-cookies",
                "supports-cookies"
            ));
})(themeVendor.ScrollLock, themeVendor.ajaxinate, themeVendor.Flickity, themeVendor.FlickityFade);
